import React, { useRef, useCallback, useMemo } from "react";
import { useState, useEffect } from "react";
import AddToPlanDrawer from "../plans/AddToPlanDrawer";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
  Menu,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  Switch,
  Drawer,
  ToggleButton,
  ToggleButtonGroup,
  Slider,
  Checkbox,
  Popover,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled, alpha } from "@mui/material/styles";
import MuiTableSkeleton from "../skeleton/MuiTableSkeleton";
import pluginrequests from "../../services/pluginrequests";
import usersEndpoints from "../../services/userServices";
import CircularProgress from "@mui/material/CircularProgress";
import { useCookies } from "react-cookie";
import "./css/dashboard.css";
import {
  ExpandMore,
  Lock,
  QueryStats,
  ArrowDropDown,
  Search,
  Star,
  DescriptionOutlined,
  GridOnOutlined,
} from "@mui/icons-material";
import ReactGA from "react-ga4";
import {
  useFetchInfluencersCount,
  useFilteredInfluencers,
} from "../../react-query/hooks/useFetchInfluencers";
import influencerservice from "../../services/influencerservice";
import paymentportalservice from "../../services/paymentportalservice";
import filterServices from "../../react-query/services/filterServices";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import InboxIcon from "@mui/icons-material/Inbox";

import TableComponent from './common/tableComponent';
import ShowFilters from "./common/showFilters";
import DashboardHeaderSection from "../common/dashboardheader/DashboardHeader";
import helpers from "../../hooks/HelperFunctions";
import { LANGUAGE_OPTIONS } from "../plans/languageOptions";

import { CSVDownload } from 'react-csv';
import { triggerBrowserDownload } from '../../utils/triggerDownload';

let swalPromise = null;
const loadSwal = async() => {
  if (!swalPromise) {
    swalPromise = import('sweetalert2');
  }
  const module = await swalPromise;
  return module.default;
}

const { escapeHtml } = helpers;

function buildContactModalHtml(username, phone, profile) {
  if (!username || !phone) return '<div style="padding:20px;text-align:center;color:#999">No contact details available</div>';

  const isYoutube = !!(profile?.youtubeData?.channel_id);
  const followers = isYoutube
    ? profile?.youtubeData?.statistics?.subscriberCount
    : profile?.instaFollowers;
  const category = profile?.category || profile?.categoryName || null;
  const gender = profile?.gender || null;
  const platform = isYoutube ? 'YouTube' : 'Instagram';
  const initials = escapeHtml((username || '').slice(0, 2).toUpperCase());
  const safeUsername = escapeHtml(username);
  const safePhone = escapeHtml(phone);
  const safePlatform = escapeHtml(platform);

  const followersFormatted = followers
    ? Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(followers))
    : null;

  const genderLabel = gender === 'M' ? '♂ Male' : gender === 'F' ? '♀ Female' : (gender ? escapeHtml(gender) : null);
  const genderBg = gender === 'M' ? '#DBEAFE' : gender === 'F' ? '#FCE7F3' : '#F3F4F6';
  const genderColor = gender === 'M' ? '#1E40AF' : gender === 'F' ? '#9D174D' : '#374151';

  const activeManager = (profile?.manager || []).find(
    m => m.isActive === true && (m.manager_name || m.agency_name)
  ) || (profile?.manager?.[0]?.manager_name || profile?.manager?.[0]?.agency_name ? profile.manager[0] : null);
  const managerName = activeManager ? escapeHtml(activeManager.manager_name || activeManager.agency_name) : null;

  const tags = [
    followersFormatted && `<span style="background:#EEF2FF;color:#3730A3;padding:5px 14px;border-radius:20px;font-size:12px;font-weight:700;display:inline-block">👥 ${escapeHtml(followersFormatted)}</span>`,
    genderLabel && `<span style="background:${genderBg};color:${genderColor};padding:5px 14px;border-radius:20px;font-size:12px;font-weight:700;display:inline-block">${genderLabel}</span>`,
    category && `<span style="background:#D1FAE5;color:#065F46;padding:5px 14px;border-radius:20px;font-size:12px;font-weight:700;display:inline-block">📌 ${escapeHtml(category)}</span>`,
  ].filter(Boolean).join('');

  return `
    <div style="font-family:'Quicksand','Segoe UI',sans-serif">
      <div style="background:linear-gradient(135deg,#FF5200 0%,#FF8C00 100%);margin:-20px -20px 0;padding:24px 20px 20px;position:relative;overflow:hidden;border-radius:4px 4px 0 0">
        <div style="position:absolute;top:-15px;right:-15px;width:70px;height:70px;background:rgba(255,255,255,0.1);border-radius:50%"></div>
        <div style="position:absolute;bottom:-25px;left:-5px;width:90px;height:90px;background:rgba(255,255,255,0.07);border-radius:50%"></div>
        <div style="position:relative;display:flex;align-items:center;gap:14px">
          <div style="width:50px;height:50px;min-width:50px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:800;color:white;border:2px solid rgba(255,255,255,0.4)">${initials}</div>
          <div>
            <div style="font-size:17px;font-weight:800;color:white;line-height:1.2">@${safeUsername}</div>
            <div style="font-size:11px;color:rgba(255,255,255,0.8);margin-top:3px;font-weight:600">${safePlatform} Creator</div>
          </div>
        </div>
      </div>
      <div style="padding:18px 0 4px">
        <div style="background:#FFF5F0;border:1.5px solid rgba(255,82,0,0.2);border-radius:12px;padding:16px 20px;text-align:center;margin-bottom:14px">
          <div style="font-size:10px;font-weight:700;color:#999;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:8px">📞 Contact Number</div>
          <div style="font-size:22px;font-weight:800;color:#FF5200;letter-spacing:2px;margin-bottom:${managerName ? '6px' : '12px'}">${safePhone}</div>
          ${managerName ? `<div style="font-size:11px;font-weight:600;color:#888;margin-bottom:12px">👤 Manager: ${managerName}</div>` : ''}
          <button id="meesha-copy-btn" style="background:#FF5200;color:white;border:none;padding:8px 24px;border-radius:24px;font-size:12px;font-weight:700;cursor:pointer;font-family:'Quicksand','Segoe UI',sans-serif;letter-spacing:0.5px">Copy Number</button>
        </div>
        ${tags ? `<div style="display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-top:4px">${tags}</div>` : ''}
      </div>
    </div>
  `;
}

function showContactModal(Swal, username, phone, profile) {
  Swal.fire({
    html: buildContactModalHtml(username, phone, profile),
    showCloseButton: true,
    showConfirmButton: false,
    width: 400,
    padding: '20px',
    backdrop: 'rgba(28, 28, 46, 0.6)',
    didOpen: (popup) => {
      const copyBtn = popup.querySelector('#meesha-copy-btn');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(String(phone)).catch(() => {});
          copyBtn.textContent = '✓ Copied!';
          copyBtn.style.background = '#22C55E';
          setTimeout(() => {
            copyBtn.textContent = 'Copy Number';
            copyBtn.style.background = '#FF5200';
          }, 2000);
        });
      }
    },
  });
}

const ANALYTICS_CATEGORIES = {
  FILTER: "Creator Filter",
  EXPORT: "Export",
  VIEW_CONTACT: "View Contact",
  VIEW_EMAIL: "View Email",
  REQUEST_CONTACT: "Request Contact",
};

const ANALYTICS_ACTIONS = {
  GENDER: "Gender",
  LOCATION: "Location",
  FOLLOWERS: "Followers",
  AGE: "Age",
  REEL_COST: "Reel Cost",
  PLATFORM: "Platform",
  CATEGORY: "Category",
  LANGUAGE: "Language",
  SEARCH_TERM: "Keyword",
  REPORT_EXPORT: "List Export",
  CREATOR_NAME: "Creator Name",
  ONLY_NUMBER: "Phone Available",
  TOP_CREATORS_YT: "Top Creators Youtube",
  TOP_CREATORS_IN: "Top Creators Insta",
};

const headers = [
  { label: "Username", key: "username" },
  { label: "Profile URL", key: "profileUrl" },
  { label: "Gender", key: "gender" },
  { label: "Email", key: "email" },
  { label: "Followers", key: "instaFollowers" },
  { label: "Bio", key: "biography" },
  { label: "Location", key: "state" },
  { label: "Category", key: "categoryName" },
  { label: "Contact", key: "number" },
];

const youtubeHeaders = [
  { label: "Channel Name", key: "youtubeChannel" },
  { label: "Channel Url", key: "url" },
  { label: "Channel Id", key: "channelId" },
  { label: "Gender", key: "gender" },
  { label: "Email", key: "email" },
  { label: "Subscribers", key: "youtubeSubscribers" },
  { label: "About", key: "youtubeDescription" },
  { label: "Location", key: "state" },
  { label: "Category", key: "categoryName" },
  { label: "Contact", key: "number" },
];

const buttonCss = {
  textTransform: "capitalize",
  verticalAlign: "middle",
  margin: "5px 0",
  fontSize: "11px",
  fontWeight: 700,
  fontFamily: 'Quicksand',
  borderRadius: '20px',
};

const QUICK_LOCATIONS = ['Delhi', 'Mumbai', 'Bangalore'];

const RATING_STAR_OPTIONS = [
  { stars: 5, label: 'Excellent' },
  { stars: 4, label: 'Good'      },
  { stars: 3, label: 'Average'   },
  { stars: 2, label: 'Below Avg' },
  { stars: 1, label: 'Poor'      },
];
const GOLD = '#F59E0B';
const GOLD_CHECKED = '#D97706';

// Preserves applied filters across a row click -> back-navigation round trip
// (e.g. to /payment-history/:id and back). sessionStorage, not localStorage,
// so it's scoped to this tab and clears when the tab closes.
const FILTER_SESSION_KEY = "meesha:influencerFilters:v1";

function loadPersistedFilterState() {
  try {
    const raw = sessionStorage.getItem(FILTER_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const initialFilter = {
  gender: null,
  platform: null,
  location: null,
  followers: null,
  age: null,
  reelCost: null,
  realCost: null,
  brands: null,
  categories: null,
  languages: null,
  search: null,
  page: null,
  pageSize: null,
  topYoutubers: null,
  getNumbers: null,
  engagedCreators: null,
  ratingFilters: null,
  cpe: null,
  cpv: null,
};

const FilterContent = React.memo(({
  filters,
  handleDelete,
  handleClearFilters,
  hasActiveFilters,
  gender,
  setGender,
  handleFilters,
  location,
  setLocation,
  statesList,
  minRange,
  maxRange,
  handleFollowersChange,
  followers,
  handleChange,
  minAgeRange,
  maxAgeRange,
  handleAgeChange,
  age,
  handleAgeRangeChange,
  minReelCostRange,
  maxReelCostRange,
  handleReelCostChange,
  reelCost,
  handleReelCostRangeChange,
  followersRangeError,
  ageRangeError,
  reelCostRangeError,
  platform,
  setPlatform,
  followersSliderValue,
  handleFollowersSliderChange,
  ageSliderValue,
  handleAgeSliderChange,
  reelCostSliderValue,
  handleReelCostSliderChange,
  engagedCreators,
  realCost,
  realCostSliderValue,
  handleRealCostSliderChange,
  handleRealCostRangeChange,
  minRealCostRange,
  maxRealCostRange,
  handleRealCostInputChange,
  realCostRangeError,
  brandsList,
  selectedBrands,
  handleBrandsChange,
  categoriesList,
  selectedCategories,
  handleCategoriesChange,
  languagesList,
  selectedLanguages,
  handleLanguagesChange,
  minCPERange,
  maxCPERange,
  cpeRangeError,
  handleCPEInputChange,
  minCPVRange,
  maxCPVRange,
  cpvRangeError,
  handleCPVInputChange,
  handleApplyCPE,
  handleApplyCPV,
}) => {
  const [brandSearch, setBrandSearch] = useState('');
  const [categorySearch, setCategorySearch] = useState('');
  const [languageSearch, setLanguageSearch] = useState('');
  return (
  <Box sx={{ borderRadius: '14px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 16px rgba(99,102,241,0.10), 0 12px 40px rgba(0,0,0,0.08)', border: '1px solid rgba(255,255,255,0.88)', bgcolor: 'white' }}>
    {/* Gradient header */}
    <Box
      sx={{
        background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        px: 2,
        py: 1.5,
      }}
    >
      <Typography variant="button" sx={{ fontWeight: 800, color: 'white', letterSpacing: 0.5, fontSize: '0.82rem' }}>
        Filters
      </Typography>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          cursor: hasActiveFilters ? 'pointer' : 'not-allowed',
          color: hasActiveFilters ? 'white' : 'rgba(255,255,255,0.45)',
          userSelect: 'none',
          border: hasActiveFilters ? '1px solid rgba(255,255,255,0.55)' : '1px solid transparent',
          borderRadius: 1,
          px: 1,
          py: 0.5,
          transition: 'all 0.15s ease',
          '&:hover': hasActiveFilters ? { bgcolor: 'rgba(255,255,255,0.18)' } : {},
        }}
        onClick={hasActiveFilters ? handleClearFilters : undefined}
      >
        Clear All
      </Typography>
    </Box>

    {/* Active filter chips (white zone below header) */}
    <Box sx={{ bgcolor: 'white' }}>
      <ShowFilters filters={filters} handleDelete={handleDelete} />
    </Box>

    {/* Accordion items */}
    <Box sx={{ bgcolor: 'white' }}>

    {/* Gender */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease', boxShadow: 'none' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Gender</Typography>
          {filters?.gender && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ minWidth: 80 }}>
          <RadioGroup
            name="gender"
            value={gender}
            onChange={(event) => {
              setGender(event.target.value);
              handleFilters(event.target.value, "gender");
            }}
          >
            <FormControlLabel value="F" control={<Radio />} label="Female" />
            <FormControlLabel value="M" control={<Radio />} label="Male" />
            <FormControlLabel value="O" control={<Radio />} label="Other" />
          </RadioGroup>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Location */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Location</Typography>
          {filters?.location && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Popular Cities
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mt: 0.75, mb: 2 }}>
            {QUICK_LOCATIONS.map((city) => (
              <Chip
                key={city}
                label={city}
                size="small"
                clickable
                variant={location === city ? 'filled' : 'outlined'}
                color={location === city ? 'primary' : 'default'}
                onClick={() => { setLocation(city); handleFilters(city, 'location'); }}
                sx={{ fontFamily: 'Quicksand', fontWeight: 600, fontSize: '0.72rem', transition: 'all 0.15s ease' }}
              />
            ))}
          </Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            State / UT
          </Typography>
          <Box sx={{ mt: 0.75 }}>
            {statesList.length === 0 ? (
              <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand' }}>
                Loading states…
              </Typography>
            ) : (
              <Select
                size="small"
                displayEmpty
                fullWidth
                value={statesList.includes(location) ? location : ''}
                onChange={(e) => { setLocation(e.target.value); handleFilters(e.target.value, 'location'); }}
                sx={{ fontFamily: 'Quicksand', fontSize: '0.85rem' }}
                renderValue={(val) => val || <span style={{ color: '#aaa' }}>Select a state...</span>}
              >
                {statesList.map((state) => (
                  <MenuItem key={state} value={state} sx={{ fontFamily: 'Quicksand', fontSize: '0.85rem' }}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Category */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel-category-content"
        id="panel-category-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Category</Typography>
          {filters?.categories?.length > 0 && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          {categoriesList.length === 0 ? (
            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand' }}>
              Loading categories…
            </Typography>
          ) : (
            <>
              <TextField
                size="small"
                placeholder="Search categories…"
                value={categorySearch}
                onChange={(e) => setCategorySearch(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ fontSize: 16, color: '#bbb' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 1,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    fontSize: '0.82rem',
                    fontFamily: 'Quicksand',
                    bgcolor: '#f9f9f9',
                    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                    '& fieldset': { borderColor: '#ececec' },
                    '&:hover fieldset': { borderColor: '#FF5200' },
                    '&.Mui-focused fieldset': { borderColor: '#FF5200', borderWidth: 1.5 },
                    '&.Mui-focused': { boxShadow: '0 0 0 3px rgba(255,82,0,0.10)' },
                  },
                  '& input': { py: 0.9, px: 0.5 },
                  '& input::placeholder': { color: '#bbb', opacity: 1 },
                }}
              />

              <Box sx={{ maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
                {categoriesList
                  .filter((c) => c.toLowerCase().includes(categorySearch.trim().toLowerCase()))
                  .map((cat) => {
                    const isChecked = selectedCategories.includes(cat);
                    return (
                      <FormControlLabel
                        key={cat}
                        control={
                          <Checkbox
                            checked={isChecked}
                            onChange={() =>
                              handleCategoriesChange(
                                isChecked
                                  ? selectedCategories.filter((c) => c !== cat)
                                  : [...selectedCategories, cat]
                              )
                            }
                            size="small"
                            sx={{ color: '#FF5200', '&.Mui-checked': { color: '#FF5200' }, p: 0.5 }}
                          />
                        }
                        label={<Typography sx={{ fontSize: '0.83rem', fontFamily: 'Quicksand' }}>{cat}</Typography>}
                        sx={{ display: 'flex', alignItems: 'center', m: 0, py: 0.2, width: '100%' }}
                      />
                    );
                  })}

                {categoriesList.filter((c) =>
                  c.toLowerCase().includes(categorySearch.trim().toLowerCase())
                ).length === 0 && (
                  <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand', display: 'block', textAlign: 'center', py: 1.5 }}>
                    No categories match "{categorySearch}"
                  </Typography>
                )}
              </Box>
            </>
          )}
          <Box padding={1} width="100%" display="flex" justifyContent="end" sx={{ mt: 1 }}>
            <Button
              variant="contained"
              // Disabled only when there's truly nothing to do — no staged selection
              // AND no applied filter to clear. If the user unchecks every box after
              // Category was already applied, this must stay enabled so Apply can
              // commit the now-empty selection and actually clear the filter.
              disabled={selectedCategories.length === 0 && !filters?.categories?.length}
              sx={{
                paddingY: 0.9,
                paddingX: 2.5,
                textTransform: "capitalize",
                fontSize: "11px",
                fontFamily: 'Quicksand',
                fontWeight: 700,
                borderRadius: '20px',
                background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                  boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
                },
                '&.Mui-disabled': { background: '#e0e0e0', boxShadow: 'none' },
              }}
              onClick={() => handleFilters(selectedCategories, "categories")}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Language — languagesList is the fixed LANGUAGE_OPTIONS enum, never empty
        and never fetched, so unlike Category there's no loading state to show. */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel-language-content"
        id="panel-language-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Language</Typography>
          {filters?.languages?.length > 0 && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <TextField
            size="small"
            placeholder="Search languages…"
            value={languageSearch}
            onChange={(e) => setLanguageSearch(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ fontSize: 16, color: '#bbb' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              mb: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                fontSize: '0.82rem',
                fontFamily: 'Quicksand',
                bgcolor: '#f9f9f9',
                transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                '& fieldset': { borderColor: '#ececec' },
                '&:hover fieldset': { borderColor: '#FF5200' },
                '&.Mui-focused fieldset': { borderColor: '#FF5200', borderWidth: 1.5 },
                '&.Mui-focused': { boxShadow: '0 0 0 3px rgba(255,82,0,0.10)' },
              },
              '& input': { py: 0.9, px: 0.5 },
              '& input::placeholder': { color: '#bbb', opacity: 1 },
            }}
          />

          <Box sx={{ maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
            {languagesList
              .filter((l) => l.toLowerCase().includes(languageSearch.trim().toLowerCase()))
              .map((lang) => {
                const isChecked = selectedLanguages.includes(lang);
                return (
                  <FormControlLabel
                    key={lang}
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={() =>
                          handleLanguagesChange(
                            isChecked
                              ? selectedLanguages.filter((l) => l !== lang)
                              : [...selectedLanguages, lang]
                          )
                        }
                        size="small"
                        sx={{ color: '#FF5200', '&.Mui-checked': { color: '#FF5200' }, p: 0.5 }}
                      />
                    }
                    label={<Typography sx={{ fontSize: '0.83rem', fontFamily: 'Quicksand' }}>{lang}</Typography>}
                    sx={{ display: 'flex', alignItems: 'center', m: 0, py: 0.2, width: '100%' }}
                  />
                );
              })}

            {languagesList.filter((l) =>
              l.toLowerCase().includes(languageSearch.trim().toLowerCase())
            ).length === 0 && (
              <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand', display: 'block', textAlign: 'center', py: 1.5 }}>
                No languages match "{languageSearch}"
              </Typography>
            )}
          </Box>

          <Box padding={1} width="100%" display="flex" justifyContent="end" sx={{ mt: 1 }}>
            <Button
              variant="contained"
              // Same reasoning as the Category Apply button above — must stay
              // enabled when unchecking everything is meant to clear an already-
              // applied filter, not just when adding a new selection.
              disabled={selectedLanguages.length === 0 && !filters?.languages?.length}
              sx={{
                paddingY: 0.9,
                paddingX: 2.5,
                textTransform: "capitalize",
                fontSize: "11px",
                fontFamily: 'Quicksand',
                fontWeight: 700,
                borderRadius: '20px',
                background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                  boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
                },
                '&.Mui-disabled': { background: '#e0e0e0', boxShadow: 'none' },
              }}
              onClick={() => handleFilters(selectedLanguages, "languages")}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Followers */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Followers</Typography>
          {filters?.followers && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Box sx={{ px: 1.5, pt: 0.5, pb: 1 }}>
            <Slider
              value={followersSliderValue}
              onChange={handleFollowersSliderChange}
              min={0}
              max={100000000}
              step={50000}
              valueLabelDisplay="auto"
              valueLabelFormat={(v) =>
                v >= 10000000 ? `${(v / 10000000).toFixed(0)}Cr`
                : v >= 1000000 ? `${(v / 1000000).toFixed(1)}M`
                : v >= 1000 ? `${(v / 1000).toFixed(0)}K`
                : `${v}`
              }
              sx={{ color: '#FF5200', '& .MuiSlider-thumb': { width: 14, height: 14 } }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
              <Typography variant="caption" color="text.secondary">0</Typography>
              <Typography variant="caption" color="text.secondary">100M</Typography>
            </Box>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                label="Min"
                variant="outlined"
                size="small"
                name="minrange"
                value={minRange}
                onChange={handleFollowersChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Max"
                variant="outlined"
                size="small"
                name="maxrange"
                value={maxRange}
                onChange={handleFollowersChange}
                error={!!followersRangeError}
              />
            </Grid>
          </Grid>
          {followersRangeError && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
              {followersRangeError}
            </Typography>
          )}
          <Typography
            variant="subtitle2"
            fontWeight={"800"}
            marginTop={2}
            sx={{ fontSize: "12px" }}
          >
            Select By Influencer Size
          </Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="influencerSize"
              name="range"
              value={followers.range}
              onChange={handleChange}
            >
              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="2000-10000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Nano
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  2K-10K followers
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="10000-25000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Micro
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  10K-25K followers
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="25000-100000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Mid Tier
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  25K-100K followers
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="100000-250000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Macro
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  100K-250K followers
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="250000-1000000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Mega
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  250K-1M followers
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="1000000-10000000000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      A-Listers
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  1M+ followers
                </Typography>
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
        <Box padding={1} width="100%" display="flex" justifyContent="end">
          <Button
            variant="contained"
            sx={{
              paddingY: 0.9,
              paddingX: 2.5,
              textTransform: "capitalize",
              fontSize: "11px",
              fontFamily: 'Quicksand',
              fontWeight: 700,
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
              boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
              '&:hover': {
                background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
              },
            }}
            onClick={() => handleFilters(followers, "followers")}
          >
            Apply
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Age */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel4a-content"
        id="panel4a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Age</Typography>
          {filters?.age && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Box sx={{ px: 1.5, pt: 0.5, pb: 1 }}>
            <Slider
              value={ageSliderValue}
              onChange={handleAgeSliderChange}
              min={18}
              max={65}
              step={1}
              valueLabelDisplay="auto"
              sx={{ color: '#FF5200', '& .MuiSlider-thumb': { width: 14, height: 14 } }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
              <Typography variant="caption" color="text.secondary">18</Typography>
              <Typography variant="caption" color="text.secondary">65</Typography>
            </Box>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                label="Min Age"
                variant="outlined"
                size="small"
                name="minAgeRange"
                value={minAgeRange}
                onChange={handleAgeChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Max Age"
                variant="outlined"
                size="small"
                name="maxAgeRange"
                value={maxAgeRange}
                onChange={handleAgeChange}
                error={!!ageRangeError}
              />
            </Grid>
          </Grid>
          {ageRangeError && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
              {ageRangeError}
            </Typography>
          )}
          <Typography
            variant="subtitle2"
            fontWeight={"800"}
            marginTop={2}
            sx={{ fontSize: "12px" }}
          >
            Select By Given Range
          </Typography>
          <RadioGroup
            aria-labelledby="ageSize"
            name="agerange"
            value={age.agerange}
            onChange={handleAgeRangeChange}
          >
            <Box width="100%" display="flex" justifyContent="space-between">
              <FormControlLabel
                control={<Radio />}
                value="18-30"
                label={
                  <Typography variant="body2" color="textSecondary">
                    18-30
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio />}
                value="31-35"
                label={
                  <Typography variant="body2" color="textSecondary">
                    31-35
                  </Typography>
                }
              />
            </Box>

            <Box width="100%" display="flex" justifyContent="space-between">
              <FormControlLabel
                control={<Radio />}
                value="36-40"
                label={
                  <Typography variant="body2" color="textSecondary">
                    36-40
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio />}
                value="41-45"
                label={
                  <Typography variant="body2" color="textSecondary">
                    41-45
                  </Typography>
                }
              />
            </Box>

            <Box width="100%" display="flex" justifyContent="space-between">
              <FormControlLabel
                control={<Radio />}
                value="46-50"
                label={
                  <Typography variant="body2" color="textSecondary">
                    46-50
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio />}
                value="51-55"
                label={
                  <Typography variant="body2" color="textSecondary">
                    51-55
                  </Typography>
                }
              />
            </Box>

            <Box width="100%" display="flex" justifyContent="space-between">
              <FormControlLabel
                control={<Radio />}
                value="56-60"
                label={
                  <Typography variant="body2" color="textSecondary">
                    56-60
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio />}
                value="61-65"
                label={
                  <Typography variant="body2" color="textSecondary">
                    61-65
                  </Typography>
                }
              />
            </Box>
          </RadioGroup>
        </Box>
        <Box padding={1} width="100%" display="flex" justifyContent="end">
          <Button
            variant="contained"
            sx={{
              paddingY: 0.9,
              paddingX: 2.5,
              textTransform: "capitalize",
              fontSize: "11px",
              fontFamily: 'Quicksand',
              fontWeight: 700,
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
              boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
              '&:hover': {
                background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
              },
            }}
            onClick={() => handleFilters(age, "age")}
          >
            Apply
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Reel Cost */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel5a-content"
        id="panel5a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Reel Cost</Typography>
          {filters?.reelCost && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Box sx={{ px: 1.5, pt: 0.5, pb: 1 }}>
            <Slider
              value={reelCostSliderValue}
              onChange={handleReelCostSliderChange}
              min={0}
              max={1000000}
              step={1000}
              valueLabelDisplay="auto"
              valueLabelFormat={(v) => `₹${v >= 100000 ? `${(v / 100000).toFixed(0)}L` : v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v}`}
              sx={{ color: '#FF5200', '& .MuiSlider-thumb': { width: 14, height: 14 } }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
              <Typography variant="caption" color="text.secondary">₹0</Typography>
              <Typography variant="caption" color="text.secondary">₹10L</Typography>
            </Box>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                label="Min Reel Cost"
                variant="outlined"
                size="small"
                name="minReelCostRange"
                value={minReelCostRange}
                onChange={handleReelCostChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Max Reel Cost"
                variant="outlined"
                size="small"
                name="maxReelCostRange"
                value={maxReelCostRange}
                onChange={handleReelCostChange}
                error={!!reelCostRangeError}
              />
            </Grid>
          </Grid>
          {reelCostRangeError && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
              {reelCostRangeError}
            </Typography>
          )}
          <Typography
            variant="subtitle2"
            fontWeight={"800"}
            marginTop={2}
            sx={{ fontSize: "12px" }}
          >
            Select By Given Range
          </Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="reelCostSize"
              name="reelcostrange"
              value={reelCost.reelcostrange}
              onChange={handleReelCostRangeChange}
            >
              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="1-1000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Nano
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  Barter / 1000
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="1000-5000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Micro
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  1000 - 5000
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="5000-15000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Mid Tier
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  5000 - 15000
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="15000-25000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Macro
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  15000 - 25000
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="30000-70000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      Mega
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  30000 - 70000
                </Typography>
              </Box>

              <Box width="100%" display="flex" justifyContent="space-between">
                <FormControlLabel
                  control={<Radio />}
                  value="10000-70000"
                  label={
                    <Typography variant="body2" color="textSecondary">
                      A-Listers
                    </Typography>
                  }
                />
                <Typography variant="caption" alignSelf="center">
                  10000 - 70000
                </Typography>
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
        <Box padding={1} width="100%" display="flex" justifyContent="end">
          <Button
            variant="contained"
            sx={{
              paddingY: 0.9,
              paddingX: 2.5,
              textTransform: "capitalize",
              fontSize: "11px",
              fontFamily: 'Quicksand',
              fontWeight: 700,
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
              boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
              '&:hover': {
                background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
              },
            }}
            onClick={() => handleFilters(reelCost, "reelCost")}
          >
            Apply
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>

    {/* Last Paid Amount — visible only when Engaged Creators is active */}
    {engagedCreators && (
      <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease', boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
          aria-controls="panel-lastpaid-content"
          id="panel-lastpaid-header"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Last Paid Amount</Typography>
            {filters?.realCost && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Box sx={{ px: 1.5, pt: 0.5, pb: 1 }}>
              <Slider
                value={realCostSliderValue}
                onChange={handleRealCostSliderChange}
                min={0}
                max={1000000}
                step={1000}
                valueLabelDisplay="auto"
                valueLabelFormat={(v) => `₹${v >= 100000 ? `${(v / 100000).toFixed(0)}L` : v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v}`}
                sx={{ color: '#FF5200', '& .MuiSlider-thumb': { width: 14, height: 14 } }}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
                <Typography variant="caption" color="text.secondary">₹0</Typography>
                <Typography variant="caption" color="text.secondary">₹10L</Typography>
              </Box>
            </Box>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  label="Min"
                  variant="outlined"
                  size="small"
                  name="minRealCostRange"
                  value={minRealCostRange}
                  onChange={handleRealCostInputChange}
                  inputProps={{ inputMode: "numeric" }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Max"
                  variant="outlined"
                  size="small"
                  name="maxRealCostRange"
                  value={maxRealCostRange}
                  onChange={handleRealCostInputChange}
                  inputProps={{ inputMode: "numeric" }}
                  error={!!realCostRangeError}
                />
              </Grid>
            </Grid>
            {realCostRangeError && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                {realCostRangeError}
              </Typography>
            )}
            <Typography variant="subtitle2" fontWeight={800} marginTop={2} sx={{ fontSize: "12px" }}>
              Select By Given Range
            </Typography>
            <FormControl>
              <RadioGroup
                aria-labelledby="realCostSize"
                name="realcostrange"
                value={realCost.realcostrange}
                onChange={handleRealCostRangeChange}
              >
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0-5000"
                    label={<Typography variant="body2" color="textSecondary">Nano</Typography>} />
                  <Typography variant="caption" alignSelf="center">Under ₹5K</Typography>
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="5000-25000"
                    label={<Typography variant="body2" color="textSecondary">Micro</Typography>} />
                  <Typography variant="caption" alignSelf="center">₹5K – ₹25K</Typography>
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="25000-100000"
                    label={<Typography variant="body2" color="textSecondary">Mid Tier</Typography>} />
                  <Typography variant="caption" alignSelf="center">₹25K – ₹1L</Typography>
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="100000-500000"
                    label={<Typography variant="body2" color="textSecondary">Macro</Typography>} />
                  <Typography variant="caption" alignSelf="center">₹1L – ₹5L</Typography>
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="500000-1000000"
                    label={<Typography variant="body2" color="textSecondary">Mega</Typography>} />
                  <Typography variant="caption" alignSelf="center">₹5L – ₹10L</Typography>
                </Box>
              </RadioGroup>
            </FormControl>
            <Box padding={1} width="100%" display="flex" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  paddingY: 0.9,
                  paddingX: 2.5,
                  textTransform: "capitalize",
                  fontSize: "11px",
                  fontFamily: 'Quicksand',
                  fontWeight: 700,
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                  boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                    boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
                  },
                }}
                onClick={() => handleFilters(realCost, "realCost")}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    )}

    {/* CPE Filter — visible only when Engaged Creators is active */}
    {engagedCreators && (
      <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease', boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
          aria-controls="panel-cpe-content"
          id="panel-cpe-header"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>CPE</Typography>
            <Typography sx={{ fontSize: '0.72rem', fontFamily: 'Quicksand', color: '#6B7280' }}>Cost Per Engagement</Typography>
            {filters?.cpe && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  label="Min"
                  variant="outlined"
                  size="small"
                  name="minCPERange"
                  value={minCPERange}
                  onChange={handleCPEInputChange}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Max"
                  variant="outlined"
                  size="small"
                  name="maxCPERange"
                  value={maxCPERange}
                  onChange={handleCPEInputChange}
                  inputProps={{ inputMode: 'decimal' }}
                  error={!!cpeRangeError}
                />
              </Grid>
            </Grid>
            {cpeRangeError && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                {cpeRangeError}
              </Typography>
            )}
            <Typography variant="subtitle2" fontWeight={800} marginTop={2} sx={{ fontSize: '12px' }}>
              Select By Given Range
            </Typography>
            <FormControl>
              <RadioGroup
                name="cperange"
                value={filters?.cpe?.cperange || ''}
                onChange={(e) => handleFilters({ cperange: e.target.value }, 'cpe')}
              >
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0-0.5"
                    label={<Typography variant="body2" color="textSecondary">Below ₹0.50</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0.5-1"
                    label={<Typography variant="body2" color="textSecondary">₹0.50 – ₹1</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="1-5"
                    label={<Typography variant="body2" color="textSecondary">₹1 – ₹5</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="5-10"
                    label={<Typography variant="body2" color="textSecondary">₹5 – ₹10</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="10-"
                    label={<Typography variant="body2" color="textSecondary">Above ₹10</Typography>} />
                </Box>
              </RadioGroup>
            </FormControl>
            <Box padding={1} width="100%" display="flex" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  paddingY: 0.9, paddingX: 2.5,
                  textTransform: 'capitalize', fontSize: '11px',
                  fontFamily: 'Quicksand', fontWeight: 700, borderRadius: '20px',
                  background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                  boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                  '&:hover': { background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)', boxShadow: '0 4px 14px rgba(255,82,0,0.35)' },
                }}
                onClick={handleApplyCPE}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    )}

    {/* CPV Filter — visible only when Engaged Creators is active */}
    {engagedCreators && (
      <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease', boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
          aria-controls="panel-cpv-content"
          id="panel-cpv-header"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>CPV</Typography>
            <Typography sx={{ fontSize: '0.72rem', fontFamily: 'Quicksand', color: '#6B7280' }}>Cost Per View</Typography>
            {filters?.cpv && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  label="Min"
                  variant="outlined"
                  size="small"
                  name="minCPVRange"
                  value={minCPVRange}
                  onChange={handleCPVInputChange}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Max"
                  variant="outlined"
                  size="small"
                  name="maxCPVRange"
                  value={maxCPVRange}
                  onChange={handleCPVInputChange}
                  inputProps={{ inputMode: 'decimal' }}
                  error={!!cpvRangeError}
                />
              </Grid>
            </Grid>
            {cpvRangeError && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                {cpvRangeError}
              </Typography>
            )}
            <Typography variant="subtitle2" fontWeight={800} marginTop={2} sx={{ fontSize: '12px' }}>
              Select By Given Range
            </Typography>
            <FormControl>
              <RadioGroup
                name="cpvrange"
                value={filters?.cpv?.cpvrange || ''}
                onChange={(e) => handleFilters({ cpvrange: e.target.value }, 'cpv')}
              >
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0-0.10"
                    label={<Typography variant="body2" color="textSecondary">Below ₹0.10</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0.10-0.2"
                    label={<Typography variant="body2" color="textSecondary">₹0.10 – ₹0.20</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0.2-0.5"
                    label={<Typography variant="body2" color="textSecondary">₹0.20 – ₹0.50</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="0.5-1"
                    label={<Typography variant="body2" color="textSecondary">₹0.50 – ₹1</Typography>} />
                </Box>
                <Box width="100%" display="flex" justifyContent="space-between">
                  <FormControlLabel control={<Radio />} value="1-"
                    label={<Typography variant="body2" color="textSecondary">Above ₹1</Typography>} />
                </Box>
              </RadioGroup>
            </FormControl>
            <Box padding={1} width="100%" display="flex" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  paddingY: 0.9, paddingX: 2.5,
                  textTransform: 'capitalize', fontSize: '11px',
                  fontFamily: 'Quicksand', fontWeight: 700, borderRadius: '20px',
                  background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                  boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                  '&:hover': { background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)', boxShadow: '0 4px 14px rgba(255,82,0,0.35)' },
                }}
                onClick={handleApplyCPV}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    )}

    {/* Brands — visible only when Engaged Creators is active */}
    {engagedCreators && (
      <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease', boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
          aria-controls="panel-brands-content"
          id="panel-brands-header"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Brands</Typography>
            {filters?.brands?.length > 0 && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            {brandsList.length === 0 ? (
              <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand' }}>
                Loading brands…
              </Typography>
            ) : (
              <>
                <TextField
                  size="small"
                  placeholder="Search brands…"
                  value={brandSearch}
                  onChange={(e) => setBrandSearch(e.target.value)}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{ fontSize: 16, color: '#bbb' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    mb: 1,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      fontSize: '0.82rem',
                      fontFamily: 'Quicksand',
                      bgcolor: '#f9f9f9',
                      transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                      '& fieldset': { borderColor: '#ececec' },
                      '&:hover fieldset': { borderColor: '#FF5200' },
                      '&.Mui-focused fieldset': { borderColor: '#FF5200', borderWidth: 1.5 },
                      '&.Mui-focused': { boxShadow: '0 0 0 3px rgba(255,82,0,0.10)' },
                    },
                    '& input': { py: 0.9, px: 0.5 },
                    '& input::placeholder': { color: '#bbb', opacity: 1 },
                  }}
                />

                <Box sx={{ maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
                  {brandsList
                    .filter((b) => b.name.toLowerCase().includes(brandSearch.trim().toLowerCase()))
                    .map((brand) => {
                      const isChecked = selectedBrands.some(b => b._id === brand._id);
                      return (
                        <FormControlLabel
                          key={brand._id}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={() =>
                                handleBrandsChange(
                                  isChecked
                                    ? selectedBrands.filter(b => b._id !== brand._id)
                                    : [...selectedBrands, brand]
                                )
                              }
                              size="small"
                              sx={{ color: '#FF5200', '&.Mui-checked': { color: '#FF5200' }, p: 0.5 }}
                            />
                          }
                          label={<Typography sx={{ fontSize: '0.83rem', fontFamily: 'Quicksand' }}>{brand.name}</Typography>}
                          sx={{ display: 'flex', alignItems: 'center', m: 0, py: 0.2, width: '100%' }}
                        />
                      );
                    })}

                  {brandsList.filter((b) =>
                    b.name.toLowerCase().includes(brandSearch.trim().toLowerCase())
                  ).length === 0 && (
                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Quicksand', display: 'block', textAlign: 'center', py: 1.5 }}>
                      No brands match "{brandSearch}"
                    </Typography>
                  )}
                </Box>
              </>
            )}
            <Box padding={1} width="100%" display="flex" justifyContent="end" sx={{ mt: 1 }}>
              <Button
                variant="contained"
                // Same reasoning as the Category/Language Apply buttons — must stay
                // enabled when unchecking everything is meant to clear an already-
                // applied filter, not just when adding a new selection.
                disabled={selectedBrands.length === 0 && !filters?.brands?.length}
                sx={{
                  paddingY: 0.9,
                  paddingX: 2.5,
                  textTransform: "capitalize",
                  fontSize: "11px",
                  fontFamily: 'Quicksand',
                  fontWeight: 700,
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                  boxShadow: '0 3px 10px rgba(255,82,0,0.25)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
                    boxShadow: '0 4px 14px rgba(255,82,0,0.35)',
                  },
                  '&.Mui-disabled': { background: '#e0e0e0', boxShadow: 'none' },
                }}
                onClick={() => handleFilters(selectedBrands, "brands")}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    )}

    {/* Platform */}
    <Accordion sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #F0F0F0', '&:hover': { bgcolor: '#FAFAFA' }, transition: 'background-color 0.15s ease' }}>
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: '#FF5200', fontSize: '1.1rem' }} />}
        aria-controls="panel6a-content"
        id="panel6a-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', fontFamily: 'Quicksand' }}>Platform</Typography>
          {filters?.platform && <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#FF5200', display: 'inline-block', flexShrink: 0 }} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ minWidth: 85 }}>
          <RadioGroup
            name="platform"
            value={platform}
            onChange={(event) => {
              setPlatform(event.target.value);
              handleFilters(event.target.value, "platform");
            }}
          >
            <FormControlLabel
              value="Instagram"
              control={<Radio />}
              label="Instagram"
            />
            <FormControlLabel
              value="Youtube"
              control={<Radio />}
              label="Youtube"
            />
            <FormControlLabel
              value="Twitter"
              control={<Radio />}
              label="X (Twitter)"
            />
            <FormControlLabel
              value="Linkedin"
              control={<Radio />}
              label="LinkedIn"
            />
          </RadioGroup>
        </Box>
      </AccordionDetails>
    </Accordion>

    </Box>
  </Box>
  );
});

const FlaggedCreatorsControl = React.memo(({ flaggedCreators, selectedStars, handleFiltersToolbar }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleStarToggle = (star) => {
    const next = selectedStars.includes(star)
      ? selectedStars.filter(s => s !== star)
      : [...selectedStars, star];
    handleFiltersToolbar(next, "ratingFilters");
  };

  const pillLabel = selectedStars.length
    ? selectedStars.slice().sort((a, b) => b - a).join(', ') + ' ★'
    : 'All Ratings';

  const hasSelection = selectedStars.length > 0;

  return (
    <>
      <FormGroup sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.83rem', fontFamily: 'Quicksand', fontWeight: 600 } }}>
        <FormControlLabel
          control={
            <Switch
              checked={flaggedCreators}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: '#FF5200' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FF7A00' },
              }}
            />
          }
          label="Flagged Creators"
          size="small"
          onChange={(ev) => handleFiltersToolbar(ev.target.checked, "flaggedCreators")}
        />
      </FormGroup>

      {flaggedCreators && (
        <>
          <Box
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{
              display: 'flex', alignItems: 'center', gap: 0.5,
              cursor: 'pointer', border: '1.5px solid',
              borderColor: hasSelection ? GOLD : '#D1D5DB',
              borderRadius: 2, px: 1.2, py: 0.45,
              background: hasSelection
                ? 'linear-gradient(135deg, rgba(251,191,36,0.12) 0%, rgba(245,158,11,0.08) 100%)'
                : 'white',
              transition: 'all 0.18s',
              '&:hover': {
                borderColor: GOLD,
                background: 'linear-gradient(135deg, rgba(251,191,36,0.14) 0%, rgba(245,158,11,0.10) 100%)',
              },
            }}
          >
            <Star sx={{ fontSize: 14, color: hasSelection ? GOLD : '#9CA3AF' }} />
            <Typography sx={{
              fontSize: '0.78rem', fontFamily: 'Quicksand', fontWeight: 700,
              color: hasSelection ? GOLD_CHECKED : '#6B7280',
              letterSpacing: 0.2,
            }}>
              {pillLabel}
            </Typography>
            <ArrowDropDown sx={{ fontSize: 16, color: hasSelection ? GOLD : '#9CA3AF', ml: -0.3 }} />
          </Box>

          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{
              elevation: 0,
              sx: {
                mt: 0.6, borderRadius: 2.5,
                border: '1px solid rgba(245,158,11,0.25)',
                boxShadow: '0 8px 32px rgba(245,158,11,0.15), 0 2px 8px rgba(0,0,0,0.08)',
                overflow: 'hidden',
              },
            }}
          >
            {/* Golden header */}
            <Box sx={{
              px: 2, py: 1,
              background: 'linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%)',
              borderBottom: '1px solid rgba(245,158,11,0.2)',
              display: 'flex', alignItems: 'center', gap: 0.75,
            }}>
              <Star sx={{ fontSize: 13, color: GOLD }} />
              <Typography sx={{
                fontSize: '0.68rem', fontFamily: 'Quicksand', fontWeight: 800,
                color: GOLD_CHECKED, textTransform: 'uppercase', letterSpacing: 1,
              }}>
                Star Rating
              </Typography>
            </Box>

            <Box sx={{ p: 1, minWidth: 180 }}>
              {RATING_STAR_OPTIONS.map(({ stars, label }) => (
                <Box
                  key={stars}
                  onClick={() => handleStarToggle(stars)}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: 0.75,
                    py: 0.6, px: 0.75, borderRadius: 1.5, cursor: 'pointer',
                    transition: 'background 0.12s',
                    '&:hover': { background: 'rgba(245,158,11,0.08)' },
                  }}
                >
                  <Checkbox
                    checked={selectedStars.includes(stars)}
                    size="small"
                    disableRipple
                    sx={{
                      p: 0,
                      color: '#D1D5DB',
                      '&.Mui-checked': { color: GOLD },
                    }}
                  />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.15 }}>
                    {Array.from({ length: stars }).map((_, i) => (
                      <Star key={i} sx={{ fontSize: 14, color: GOLD }} />
                    ))}
                  </Box>
                  <Typography sx={{
                    fontSize: '0.77rem', fontFamily: 'Quicksand', fontWeight: 600,
                    color: selectedStars.includes(stars) ? GOLD_CHECKED : '#6B7280',
                    transition: 'color 0.12s',
                  }}>
                    {label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Popover>
        </>
      )}
    </>
  );
});

const FilterSliderBar = React.memo(({
  isMobileFilter,
  drawerOpen,
  setDrawerOpen,
  handleClearFilters,
  filters,
  handleDelete,
  gender,
  setGender,
  handleFilters,
  location,
  setLocation,
  statesList,
  minRange,
  maxRange,
  handleFollowersChange,
  followers,
  handleChange,
  minAgeRange,
  maxAgeRange,
  handleAgeChange,
  age,
  handleAgeRangeChange,
  minReelCostRange,
  maxReelCostRange,
  handleReelCostChange,
  reelCost,
  handleReelCostRangeChange,
  followersRangeError,
  ageRangeError,
  reelCostRangeError,
  platform,
  setPlatform,
  realCost,
  realCostSliderValue,
  handleRealCostSliderChange,
  handleRealCostRangeChange,
  minRealCostRange,
  maxRealCostRange,
  handleRealCostInputChange,
  realCostRangeError,
  brandsList,
  selectedBrands,
  handleBrandsChange,
  categoriesList,
  selectedCategories,
  handleCategoriesChange,
  languagesList,
  selectedLanguages,
  handleLanguagesChange,
  count,
  countLoading,
  isContacts,
  engagedCreators,
  engagedSort,
  handleEngagedSort,
  flaggedCreators,
  selectedStars,
  minCPERange,
  maxCPERange,
  cpeRangeError,
  handleCPEInputChange,
  minCPVRange,
  maxCPVRange,
  cpvRangeError,
  handleCPVInputChange,
  handleApplyCPE,
  handleApplyCPV,
  handleFiltersToolbar,
  filters: filtersToolbar,
  exportList,
  handleExportClick,
  handleExportExcelClick,
  isExportingExcel,
  initiateDownload,
  exportData,
  profilesLoading,
  isFetching,
  profilesError,
  profiles,
  allCreators,
  credits,
  numbers,
  ageFormatter,
  contactFormatter,
  categoryFormatter,
  handleEmailButton,
  handleCheckboxClick,
  handleContactRequestButton,
  handleSort,
  tableSort,
  cookies,
  handleCreatorDelete,
  handlePageChange,
  page,
  cursor,
  onDeselectAll,
  onOpenAddToPlan,
  onSelectHundred,
  hasMore,
  isSelectingHundred,
  selectCount,
  onSelectCountChange,
  followersSliderValue,
  handleFollowersSliderChange,
  ageSliderValue,
  handleAgeSliderChange,
  reelCostSliderValue,
  handleReelCostSliderChange,
}) => {
  const [selectMenuAnchor, setSelectMenuAnchor] = useState(null);
  const [exportMenuAnchor, setExportMenuAnchor] = useState(null);
  const hasActiveFilters = useMemo(
    () => Object.values(filters).some(v => v !== null) || isContacts || engagedCreators || flaggedCreators,
    [filters, isContacts, engagedCreators, flaggedCreators]
  );

  const filterContentProps = useMemo(() => ({
    filters,
    handleDelete,
    handleClearFilters,
    hasActiveFilters,
    gender,
    setGender,
    handleFilters,
    location,
    setLocation,
    statesList,
    minRange,
    maxRange,
    handleFollowersChange,
    followers,
    handleChange,
    minAgeRange,
    maxAgeRange,
    handleAgeChange,
    age,
    handleAgeRangeChange,
    minReelCostRange,
    maxReelCostRange,
    handleReelCostChange,
    reelCost,
    handleReelCostRangeChange,
    followersRangeError,
    ageRangeError,
    reelCostRangeError,
    platform,
    setPlatform,
    followersSliderValue,
    handleFollowersSliderChange,
    ageSliderValue,
    handleAgeSliderChange,
    reelCostSliderValue,
    handleReelCostSliderChange,
    engagedCreators,
    realCost,
    realCostSliderValue,
    handleRealCostSliderChange,
    handleRealCostRangeChange,
    minRealCostRange,
    maxRealCostRange,
    handleRealCostInputChange,
    realCostRangeError,
    brandsList,
    selectedBrands,
    handleBrandsChange,
    categoriesList,
    selectedCategories,
    handleCategoriesChange,
    languagesList,
    selectedLanguages,
    handleLanguagesChange,
    minCPERange,
    maxCPERange,
    cpeRangeError,
    handleCPEInputChange,
    minCPVRange,
    maxCPVRange,
    cpvRangeError,
    handleCPVInputChange,
    handleApplyCPE,
    handleApplyCPV,
  }), [filters, handleDelete, handleClearFilters, hasActiveFilters, gender, setGender, handleFilters, location, setLocation, statesList, minRange, maxRange, handleFollowersChange, followers, handleChange, minAgeRange, maxAgeRange, handleAgeChange, age, handleAgeRangeChange, minReelCostRange, maxReelCostRange, handleReelCostChange, reelCost, handleReelCostRangeChange, followersRangeError, ageRangeError, reelCostRangeError, platform, setPlatform, followersSliderValue, handleFollowersSliderChange, ageSliderValue, handleAgeSliderChange, reelCostSliderValue, handleReelCostSliderChange, engagedCreators, realCost, realCostSliderValue, handleRealCostSliderChange, handleRealCostRangeChange, minRealCostRange, maxRealCostRange, handleRealCostInputChange, realCostRangeError, brandsList, selectedBrands, handleBrandsChange, categoriesList, selectedCategories, handleCategoriesChange, languagesList, selectedLanguages, handleLanguagesChange, minCPERange, maxCPERange, cpeRangeError, handleCPEInputChange, minCPVRange, maxCPVRange, cpvRangeError, handleCPVInputChange, handleApplyCPE, handleApplyCPV]);

  // Use accumulated allCreators (pages 1+) if populated; fall back to the raw
  // react-query response when allCreators is still [] waiting for the useEffect
  // to run. This prevents a blank flash between query resolution and state update.
  const displayCreators = allCreators.length > 0 ? allCreators : (profiles?.data?.influencers ?? []);

  /* ── Creator-network canvas background ─────────────────────── */
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let rafId = null, lastTs = 0, visible = true;
    const FPS_CAP = 1000 / 40;

    const resize = () => {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize, { passive: true });

    const io = new IntersectionObserver(([e]) => {
      visible = e.isIntersecting;
      if (visible && !rafId) rafId = requestAnimationFrame(animate);
    }, { threshold: 0 });
    io.observe(canvas);

    // 8 hub nodes (large, pulsing) + 47 satellites — on dark banner, glow effects work correctly
    const nodes = Array.from({ length: 55 }, (_, i) => ({
      x:     Math.random(),
      y:     Math.random(),
      vx:    (Math.random() - 0.5) * 0.00042,
      vy:    (Math.random() - 0.5) * 0.00042,
      r:     i < 8 ? 9 + Math.random() * 5 : 3 + Math.random() * 2.5,
      isHub: i < 8,
      coral: Math.random() > 0.42,
      phase: Math.random() * Math.PI * 2,
    }));

    const animate = (ts) => {
      if (!visible) { rafId = null; return; }
      rafId = requestAnimationFrame(animate);
      if (ts - lastTs < FPS_CAP) return;
      lastTs = ts;

      const w = canvas.width, h = canvas.height;
      ctx.clearRect(0, 0, w, h);

      nodes.forEach(n => {
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0) n.x = 1; if (n.x > 1) n.x = 0;
        if (n.y < 0) n.y = 1; if (n.y > 1) n.y = 0;
        if (n.isHub) n.phase += 0.048;
      });

      // Links — bright colors for dark background
      const linkPx = w * 0.17;
      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const dx = (nodes[i].x - nodes[j].x) * w;
          const dy = (nodes[i].y - nodes[j].y) * h;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < linkPx) {
            const alpha = (1 - dist / linkPx) * 0.22;
            ctx.beginPath();
            ctx.moveTo(nodes[i].x * w, nodes[i].y * h);
            ctx.lineTo(nodes[j].x * w, nodes[j].y * h);
            ctx.strokeStyle = (nodes[i].coral || nodes[j].coral)
              ? `rgba(255,120,60,${alpha})`
              : `rgba(120,100,255,${alpha})`;
            ctx.lineWidth = 1.4;
            ctx.stroke();
          }
        }
      }

      // Nodes — colored glow works perfectly on dark background
      nodes.forEach(n => {
        const pulse = n.isHub ? Math.sin(n.phase) * 3 : 0;
        const r = Math.max(0.5, n.r + pulse);

        ctx.save();

        if (n.isHub) {
          ctx.shadowColor = n.coral ? 'rgba(255,107,53,0.80)' : 'rgba(130,120,255,0.75)';
          ctx.shadowBlur = 26;
          ctx.beginPath();
          ctx.arc(n.x * w, n.y * h, r, 0, Math.PI * 2);
          ctx.fillStyle = n.coral ? 'rgba(255,107,53,0.94)' : 'rgba(140,130,255,0.90)';
          ctx.fill();
        } else {
          ctx.shadowColor = n.coral ? 'rgba(255,107,53,0.42)' : 'rgba(99,102,241,0.40)';
          ctx.shadowBlur = 11;
          ctx.beginPath();
          ctx.arc(n.x * w, n.y * h, r, 0, Math.PI * 2);
          ctx.fillStyle = n.coral ? 'rgba(255,107,53,0.74)' : 'rgba(110,100,240,0.70)';
          ctx.fill();
        }

        ctx.restore();
      });
    };

    rafId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(rafId);
      io.disconnect();
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <Box
      width={{ xs: "100%", lg: `calc(100% - 80px)` }}
      marginLeft={{ xs: "0px", lg: `80px` }}
      marginTop={8}
      paddingTop={1}
      sx={{ position: 'relative', background: 'linear-gradient(145deg, #EDF1FF 0%, #F2EEFF 38%, #FFF0ED 100%)', backgroundAttachment: 'fixed', minHeight: '100vh' }}
    >
      {/* Dot-grid on page background */}
      <Box sx={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(rgba(99,102,241,0.06) 1.5px, transparent 1.5px)', backgroundSize: '28px 28px', pointerEvents: 'none', zIndex: 0 }} />

      {/* ── Animated header banner ─────────────────────────────────────── */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          mx: 2,
          mt: 1,
          mb: 2.5,
          minHeight: { xs: '110px', sm: '158px' },
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #0D1B3E 0%, #0A1228 60%, #111440 100%)',
          overflow: 'hidden',
          boxShadow: '0 4px 28px rgba(0,0,0,0.20), 0 1px 4px rgba(0,0,0,0.10)',
        }}
      >
        {/* Canvas lives inside the banner — fully visible, never behind cards */}
        <canvas
          ref={canvasRef}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', display: 'block', pointerEvents: 'none', zIndex: 0 }}
        />

        {/* Ambient glows inside banner */}
        <Box sx={{ position: 'absolute', width: 450, height: 450, top: '-130px', right: '14%', background: 'radial-gradient(circle, rgba(255,107,53,0.13) 0%, transparent 65%)', pointerEvents: 'none', zIndex: 0 }} />
        <Box sx={{ position: 'absolute', width: 340, height: 340, bottom: '-100px', left: '5%', background: 'radial-gradient(circle, rgba(99,102,241,0.11) 0%, transparent 65%)', pointerEvents: 'none', zIndex: 0 }} />

        {/* Content overlay */}
        <Box sx={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: { xs: 2.5, md: 4 } }}>
          {/* Left: label + title + subtitle */}
          <Box>
            <Box component="span" sx={{ display: 'inline-block', color: '#FF6B35', bgcolor: 'rgba(255,107,53,0.12)', border: '1px solid rgba(255,107,53,0.28)', px: '10px', py: '3px', borderRadius: '100px', fontSize: '9px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 1 }}>
              Creator Intelligence
            </Box>
            <Typography sx={{ fontSize: { xs: '17px', md: '22px' }, fontWeight: 800, color: 'white', lineHeight: 1.2 }}>
              Discover the right creators
            </Typography>
            <Typography sx={{ fontSize: '12.5px', color: 'rgba(255,255,255,0.40)', mt: 0.6 }}>
              India's largest verified creator database
            </Typography>
          </Box>

          {/* Right: stat pills — hidden on small screens */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1.5 }}>
            {[{ v: '2M+', l: 'Creator Profiles' }, { v: '3K+', l: 'Campaigns Run' }, { v: '95%', l: 'Contact Reach' }].map(({ v, l }) => (
              <Box key={l} sx={{ px: 2.5, py: 1.5, borderRadius: '12px', bgcolor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)', backdropFilter: 'blur(8px)', textAlign: 'center' }}>
                <Typography sx={{ fontSize: '20px', fontWeight: 800, color: 'white', lineHeight: 1 }}>{v}</Typography>
                <Typography sx={{ fontSize: '9px', color: 'rgba(255,255,255,0.35)', mt: 0.6, textTransform: 'uppercase', letterSpacing: '0.07em' }}>{l}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {isMobileFilter && (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box
            sx={{ width: { xs: '85vw', sm: 300 }, p: 2, overflowY: "auto" }}
            role="presentation"
          >
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
              <IconButton
                onClick={() => setDrawerOpen(false)}
                aria-label="close filters"
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <FilterContent {...filterContentProps} />
          </Box>
        </Drawer>
      )}

      <Grid container sx={{ position: 'relative', zIndex: 1 }}>
        {!isMobileFilter && (
          <Grid item lg={3} sx={{ paddingX: 2 }}>
            <Box
              sx={{
                overflowY: "auto",
                height: "85vh",
                position: "sticky",
                top: { xs: '56px', sm: '64px' },
              }}
              className="filterScroll"
            >
              <FilterContent {...filterContentProps} />
            </Box>
          </Grid>
        )}

        <Grid item xs={12} lg={isMobileFilter ? 12 : 9}>
          <Box
            marginRight={2}
            className="toolbar-animate"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: 'center',
              flex: 1,
              overflowX: 'auto',
              background: 'rgba(255,255,255,0.92)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              padding: "8px 16px",
              position: "sticky",
              top: { xs: '56px', sm: '64px' },
              zIndex: 2,
              borderRadius: 1.5,
              boxShadow: '0 4px 24px rgba(255,82,0,0.1), 0 1px 4px rgba(0,0,0,0.06)',
              borderBottom: '2px solid rgba(255,82,0,0.15)',
            }}
          >
            <Box sx={{ display: "flex", alignItems: 'center', flexShrink: 0 }}>
              {isMobileFilter && (
                <IconButton
                  onClick={() => setDrawerOpen(true)}
                  size="small"
                  sx={{ mr: 1 }}
                >
                  <FilterAltIcon />
                </IconButton>
              )}
              <Box
                className={!countLoading && count?.data?.count ? "count-badge-animate" : ""}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                  opacity: countLoading ? 0.65 : 1,
                  borderRadius: '20px',
                  px: 1.5,
                  py: 0.5,
                  minWidth: 96,
                  transition: 'opacity 0.3s ease',
                }}
              >
                {countLoading && <CircularProgress size={13} sx={{ color: 'rgba(255,255,255,0.8)' }} />}
                <Typography sx={{
                  color: 'white',
                  fontWeight: 800,
                  fontSize: '0.76rem',
                  fontFamily: 'Quicksand',
                  letterSpacing: 0.2,
                }}>
                  {count?.data?.count !== undefined
                    ? `${Number(count.data.count).toLocaleString('en-IN')} Creators`
                    : countLoading ? 'Loading...' : '—'}
                </Typography>
              </Box>
              &nbsp;
              <FormGroup sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.83rem', fontFamily: 'Quicksand', fontWeight: 600 } }}>
                <FormControlLabel
                  control={<Switch checked={isContacts} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#FF5200' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FF7A00' } }} />}
                  label="Verified Contacts"
                  size="small"
                  onChange={(ev) => {
                    ReactGA.event({
                      category: ANALYTICS_CATEGORIES.FILTER,
                      action: ANALYTICS_ACTIONS.ONLY_NUMBER,
                      label: ev.target.checked === true ? "Active" : "Inactive",
                    });
                    handleFiltersToolbar("Only Contacts", "getNumbers");
                  }}
                />
              </FormGroup>

              <FormGroup sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.83rem', fontFamily: 'Quicksand', fontWeight: 600 } }}>
                <FormControlLabel
                  control={<Switch checked={engagedCreators} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#FF5200' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FF7A00' } }} />}
                  label="Engaged Creators"
                  size="small"
                  onChange={(ev) => handleFiltersToolbar(ev.target.checked, "engagedCreators")}
                />
              </FormGroup>

              {engagedCreators && (
                <ToggleButtonGroup
                  value={engagedSort}
                  exclusive
                  onChange={(_, val) => handleEngagedSort(val)}
                  size="small"
                  sx={{
                    height: 30,
                    alignSelf: "center",
                    '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 12, px: 1.5 },
                    '& .MuiToggleButton-root.Mui-selected': {
                      color: '#FF5200',
                      backgroundColor: 'rgba(255,82,0,0.15)',
                      borderColor: '#FF5200',
                    },
                    '& .MuiToggleButton-root.Mui-selected:hover': {
                      backgroundColor: 'rgba(255,82,0,0.22)',
                    },
                  }}
                >
                  <ToggleButton value="followers" sx={{ textTransform: "none", fontSize: 12, px: 1.5 }}>
                    Followers
                  </ToggleButton>
                  <ToggleButton value="engagement" sx={{ textTransform: "none", fontSize: 12, px: 1.5 }}>
                    Engagement
                  </ToggleButton>
                </ToggleButtonGroup>
              )}

              <FlaggedCreatorsControl
                flaggedCreators={flaggedCreators}
                selectedStars={selectedStars}
                handleFiltersToolbar={handleFiltersToolbar}
              />
            </Box>

            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
              {filtersToolbar.platform === "Youtube" && (
                <>
                  <FormControl sx={{ minWidth: 150 }} size="small">
                    <InputLabel id="demo-simple-select-label">
                      Top Youtubers
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Top Youtubers"
                      name="topYoutubers"
                      onChange={(e) =>
                        handleFiltersToolbar(e.target.value, "topYoutubers")
                      }
                    >
                      <MenuItem value={"Top 50"}>
                        <QueryStats sx={{ fontSize: "16px" }} />
                        &nbsp;Top 50
                      </MenuItem>
                      <MenuItem value={"Top 100"}>
                        <QueryStats sx={{ fontSize: "16px" }} />
                        &nbsp;Top 100
                      </MenuItem>
                      <MenuItem value={"Top 500"}>
                        <QueryStats sx={{ fontSize: "16px" }} />
                        &nbsp;Top 500
                      </MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                </>
              )}
              <ButtonGroup
                variant="outlined"
                sx={{
                  mr: 1,
                  '& .MuiButtonGroup-grouped': { borderColor: '#FF5200' },
                  '& .MuiButtonGroup-grouped:hover': { borderColor: '#CC4200' },
                }}
              >
                <Button
                  onClick={onSelectHundred}
                  disabled={exportList.length >= selectCount || isSelectingHundred}
                  sx={{
                    borderColor: '#FF5200',
                    color: '#FF5200',
                    fontFamily: 'Quicksand',
                    fontWeight: 700,
                    borderRadius: '20px 0 0 20px',
                    fontSize: '0.78rem',
                    textTransform: 'none',
                    '&:hover': { borderColor: '#CC4200', color: '#CC4200', bgcolor: 'rgba(255,82,0,0.04)' },
                    '&:disabled': { borderColor: 'rgba(0,0,0,0.15)', color: 'rgba(0,0,0,0.3)' },
                  }}
                >
                  {isSelectingHundred ? 'Loading...' : `Select ${selectCount}`}
                </Button>
                <Button
                  size="small"
                  onClick={(e) => setSelectMenuAnchor(e.currentTarget)}
                  disabled={isSelectingHundred}
                  sx={{
                    borderColor: '#FF5200',
                    color: '#FF5200',
                    borderRadius: '0 20px 20px 0',
                    minWidth: '28px',
                    px: 0.5,
                    '&:hover': { borderColor: '#CC4200', color: '#CC4200', bgcolor: 'rgba(255,82,0,0.04)' },
                    '&:disabled': { borderColor: 'rgba(0,0,0,0.15)', color: 'rgba(0,0,0,0.3)' },
                  }}
                >
                  <ArrowDropDown fontSize="small" />
                </Button>
              </ButtonGroup>
              <Menu
                anchorEl={selectMenuAnchor}
                open={Boolean(selectMenuAnchor)}
                onClose={() => setSelectMenuAnchor(null)}
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 16px rgba(0,0,0,0.12)' } }}
              >
                {[50, 100, 150, 200, 250, 300, 350, 400, 450, 500].map(n => (
                  <MenuItem
                    key={n}
                    selected={n === selectCount}
                    onClick={() => { onSelectCountChange(n); setSelectMenuAnchor(null); }}
                    sx={{
                      fontFamily: 'Quicksand',
                      fontWeight: n === selectCount ? 700 : 500,
                      fontSize: '0.85rem',
                      color: n === selectCount ? '#FF5200' : 'inherit',
                    }}
                  >
                    {n}
                  </MenuItem>
                ))}
              </Menu>
              <Button
                variant="outlined"
                onClick={(e) => setExportMenuAnchor(e.currentTarget)}
                disabled={exportList.length === 0 || isExportingExcel}
                endIcon={isExportingExcel ? null : <ArrowDropDown fontSize="small" />}
                startIcon={isExportingExcel ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : null}
                sx={{
                  borderColor: '#FF5200',
                  color: '#FF5200',
                  fontFamily: 'Quicksand',
                  fontWeight: 700,
                  borderRadius: '20px',
                  fontSize: '0.78rem',
                  textTransform: 'none',
                  transition: 'all 0.15s ease',
                  '&:hover': { borderColor: '#CC4200', color: '#CC4200', bgcolor: 'rgba(255,82,0,0.04)', boxShadow: '0 2px 8px rgba(255,82,0,0.15)' },
                  '&:disabled': { borderColor: 'rgba(0,0,0,0.15)', color: 'rgba(0,0,0,0.3)' },
                }}
              >
                {isExportingExcel ? 'Exporting…' : 'Export'}
              </Button>
              <Menu
                anchorEl={exportMenuAnchor}
                open={Boolean(exportMenuAnchor)}
                onClose={() => setExportMenuAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 268,
                    p: 0.75,
                    borderRadius: '16px',
                    border: '1px solid rgba(0,0,0,0.06)',
                    boxShadow: '0 12px 32px rgba(28,28,46,0.14)',
                  },
                }}
              >
                <MenuItem
                  onClick={() => { setExportMenuAnchor(null); handleExportClick(); }}
                  sx={{
                    borderRadius: '12px',
                    py: 1,
                    px: 1.25,
                    mb: 0.5,
                    gap: 1.25,
                    '&:hover': { bgcolor: 'rgba(99,102,241,0.06)' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 0 }}>
                    <Box sx={{
                      width: 36, height: 36, borderRadius: '10px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      bgcolor: 'rgba(99,102,241,0.10)',
                    }}>
                      <DescriptionOutlined sx={{ fontSize: 20, color: '#6366F1' }} />
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary="Export to CSV"
                    secondary="Instant download · opens anywhere"
                    primaryTypographyProps={{ sx: { fontFamily: 'Quicksand', fontWeight: 700, fontSize: '0.85rem', color: '#1C1C2E' } }}
                    secondaryTypographyProps={{ sx: { fontFamily: 'Quicksand', fontSize: '0.7rem', color: 'rgba(0,0,0,0.5)' } }}
                  />
                </MenuItem>
                <MenuItem
                  onClick={() => { setExportMenuAnchor(null); handleExportExcelClick(); }}
                  sx={{
                    borderRadius: '12px',
                    py: 1,
                    px: 1.25,
                    gap: 1.25,
                    '&:hover': { bgcolor: 'rgba(29,111,66,0.06)' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 0 }}>
                    <Box sx={{
                      width: 36, height: 36, borderRadius: '10px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      bgcolor: 'rgba(29,111,66,0.10)',
                    }}>
                      <GridOnOutlined sx={{ fontSize: 20, color: '#1D6F42' }} />
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary="Export to Excel"
                    secondary="Formatted .xlsx with filters"
                    primaryTypographyProps={{ sx: { fontFamily: 'Quicksand', fontWeight: 700, fontSize: '0.85rem', color: '#1C1C2E' } }}
                    secondaryTypographyProps={{ sx: { fontFamily: 'Quicksand', fontSize: '0.7rem', color: 'rgba(0,0,0,0.5)' } }}
                  />
                </MenuItem>
              </Menu>
              {initiateDownload && (
                <CSVDownload
                  data={exportData}
                  headers={
                    filtersToolbar.platform === "Youtube"
                      ? youtubeHeaders
                      : headers
                  }
                  target="_blank"
                  filename={"influencer.csv"}
                />
              )}
            </div>
          </Box>

          <Box marginTop={1} marginRight={2} sx={{ borderRadius: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 20px rgba(99,102,241,0.08), 0 12px 40px rgba(0,0,0,0.06)', border: '1px solid rgba(255,255,255,0.90)', bgcolor: 'white' }}>
            {(profilesLoading || isFetching) && displayCreators.length === 0 ? (
              <MuiTableSkeleton />
            ) : displayCreators.length > 0 ? (
              <TableComponent
                credits={credits}
                numbers={numbers}
                filters={filtersToolbar}
                profiles={displayCreators}
                ageFormatter={ageFormatter}
                contactFormatter={contactFormatter}
                categoryFormatter={categoryFormatter}
                handleEmailButton={handleEmailButton}
                handleCheckboxClick={handleCheckboxClick}
                handleContactRequestButton={handleContactRequestButton}
                exportList={exportList}
                onSort={handleSort}
                tableSort={tableSort}
                userId={cookies?.logindata?.user?._id}
                onDelete={handleCreatorDelete}
                onDeselectAll={onDeselectAll}
                onOpenAddToPlan={onOpenAddToPlan}
                engagedCreators={engagedCreators}
              />
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "70vh", gap: 1.5 }}>
                <Box sx={{
                  width: 88,
                  height: 88,
                  borderRadius: '50%',
                  background: profilesError
                    ? 'linear-gradient(135deg, rgba(220,38,38,0.1) 0%, rgba(239,68,68,0.08) 100%)'
                    : 'linear-gradient(135deg, rgba(255,82,0,0.1) 0%, rgba(255,140,0,0.08) 100%)',
                  border: profilesError ? '2px dashed rgba(220,38,38,0.3)' : '2px dashed rgba(255,82,0,0.25)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 0.5,
                }}>
                  <InboxIcon sx={{ fontSize: 42, color: profilesError ? '#DC2626' : '#FF5200', opacity: 0.75 }} />
                </Box>
                <Typography variant="h6" sx={{ fontFamily: 'Quicksand', fontWeight: 800, color: '#1C1C2E' }}>
                  {profilesError ? 'Failed to load creators' : 'No creators found'}
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: 'Quicksand', color: 'text.secondary', textAlign: 'center', maxWidth: 280, lineHeight: 1.6 }}>
                  {profilesError
                    ? 'There was a problem connecting to the server. Please refresh the page.'
                    : 'Try adjusting your filters or search term to discover more creators.'}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          zIndex: 2,
          background: 'rgba(237,241,255,0.88)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          padding: "12px 20px",
          display: "flex",
          justifyContent: "center",
          borderTop: '1px solid rgba(99,102,241,0.12)',
        }}
      >
        <Button
          onClick={() => { handlePageChange({}, page + 1); }}
          disabled={!hasMore || isFetching}
          sx={{
            background: hasMore
              ? 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)'
              : 'linear-gradient(135deg, #D1D5DB 0%, #9CA3AF 100%)',
            color: 'white',
            borderRadius: '25px',
            px: 4,
            py: 0.9,
            fontFamily: 'Quicksand',
            fontWeight: 700,
            fontSize: '0.85rem',
            textTransform: 'none',
            boxShadow: hasMore ? '0 4px 16px rgba(255,82,0,0.3)' : 'none',
            cursor: hasMore ? 'pointer' : 'not-allowed',
            '&:hover': hasMore ? {
              background: 'linear-gradient(135deg, #CC4200 0%, #E07800 100%)',
              boxShadow: '0 6px 22px rgba(255,82,0,0.42)',
              transform: 'translateY(-2px)',
            } : {},
            '&.Mui-disabled': {
              background: 'linear-gradient(135deg, #D1D5DB 0%, #9CA3AF 100%)',
              color: 'white',
              opacity: 0.75,
            },
            transition: 'all 0.2s ease',
          }}
        >
          {hasMore ? 'Load More' : 'All Creators Loaded'}
        </Button>
      </Box>
    </Box>
  );
});

export const InfluencerFilters = () => {
  const [cookies, setCookie] = useCookies(["logindata"]);
  const inputRef = useRef(null);
  
  const [persistedFilterState] = useState(() => loadPersistedFilterState());

  const [credits, setCredits] = useState(null);
  const [isContacts, setContacts] = useState(persistedFilterState?.isContacts ?? false);
  const [initiateDownload, setInitiateDownload] = useState(false);
  const [updateDashboardCredits, setUpdateDashboardCredits] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [username, setUsername] = useState([]);
  const [userData, setUserData] = useState(null);
  const [exportData, setExportData] = useState([]);
  const [exportList, setExportList] = useState([]);
  const [isExportingExcel, setIsExportingExcel] = useState(false);
  const [requestNumbers, setRequestNumbers] = useState([]);

  const [page, setPage] = useState(1);
  const [cursor, setCursor] = useState(null);
  const nextCursorRef = useRef(null); // stores cursor for NEXT page without triggering re-fetch
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [selectedRows, setSelectedRows] = useState(0);
  const [selectCheckbox, setSelectCheckbox] = useState(0);
  const [gender, setGender] = useState("");
  const [location, setLocation] = useState("");
  const [minRange, setMinRange] = useState("");
  const [maxRange, setMaxRange] = useState("");
  const [minAgeRange, setMinAgeRange] = useState("");
  const [maxAgeRange, setMaxAgeRange] = useState("");
  const [minReelCostRange, setMinReelCostRange] = useState("");
  const [maxReelCostRange, setMaxReelCostRange] = useState("");
  const [followersRangeError, setFollowersRangeError] = useState("");
  const [ageRangeError, setAgeRangeError] = useState("");
  const [reelCostRangeError, setReelCostRangeError] = useState("");
  const [followersSliderValue, setFollowersSliderValue] = useState([0, 100000000]);
  const [ageSliderValue, setAgeSliderValue] = useState([18, 65]);
  const [reelCostSliderValue, setReelCostSliderValue] = useState([0, 1000000]);
  const [realCostSliderValue, setRealCostSliderValue] = useState([0, 1000000]);
  const [minRealCostRange, setMinRealCostRange] = useState("");
  const [maxRealCostRange, setMaxRealCostRange] = useState("");
  const [realCostRangeError, setRealCostRangeError] = useState("");
  const [tableSort, setTableSort] = useState({
    age: null,
    followers: null,
    gender: null,
  });
  const [followers, setFollowers] = useState({
    range: "",
    isCustom: false,
  });
  const [age, setAge] = useState({
    agerange: "",
  });
  const [reelCost, setReelCost] = useState({
    reelcostrange: "",
  });
  const [realCost, setRealCost] = useState({
    realcostrange: "",
  });
  
  const [filters, setFilters] = useState({
    ...initialFilter,
    ...persistedFilterState?.filters,
  });

  const [allCreators, setAllCreators] = useState([]);
  const [selectingHundred, setSelectingHundred] = useState(false);
  const [selectCount, setSelectCount] = useState(100);
  const doSelectHundredRef = React.useRef(null);

  const [platform, setPlatform] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [addToPlanOpen, setAddToPlanOpen] = useState(false);
  const isMobileFilter = useMediaQuery("(max-width:1200px)");
  const [engagedCreators, setEngagedCreators] = useState(persistedFilterState?.engagedCreators ?? false);
  const [engagedSort, setEngagedSort] = useState(persistedFilterState?.engagedSort ?? 'followers'); // 'followers' | 'engagement'
  const [flaggedCreators, setFlaggedCreators] = useState(persistedFilterState?.flaggedCreators ?? false);
  const [selectedStars, setSelectedStars] = useState(persistedFilterState?.selectedStars ?? []);

  useEffect(() => {
    try {
      sessionStorage.setItem(FILTER_SESSION_KEY, JSON.stringify({
        filters, isContacts, engagedCreators, engagedSort, flaggedCreators, selectedStars,
      }));
    } catch {
      // Private-browsing/quota errors — filters just won't survive back-navigation this time.
    }
  }, [filters, isContacts, engagedCreators, engagedSort, flaggedCreators, selectedStars]);
  const [selectedBrands, setSelectedBrands] = useState([]); // [{_id, name}]
  const [minCPERange, setMinCPERange] = useState('');
  const [maxCPERange, setMaxCPERange] = useState('');
  const [cpeRangeError, setCPERangeError] = useState('');
  const [minCPVRange, setMinCPVRange] = useState('');
  const [maxCPVRange, setMaxCPVRange] = useState('');
  const [cpvRangeError, setCPVRangeError] = useState('');
  const [brandsList, setBrandsList] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  // Unlike categoriesList (free-text, fetched from real influencer data),
  // languagesList is a fixed enum — no fetch, no loading state, never stale.
  const languagesList = LANGUAGE_OPTIONS;
  const [statesList, setStatesList] = useState([]);
  const userDataRef = useRef(userData)
  const selectedCheckboxRef = useRef(selectCheckbox);
  const selectedRowsRef = useRef(selectedRows);
  const exportListRef = useRef(exportList);

  useEffect(() => {
    selectedCheckboxRef.current = selectCheckbox;
  }, [selectCheckbox])

  useEffect(() => {
    selectedRowsRef.current = selectedRows;
  }, [selectedRows]);

  useEffect(() => {
    exportListRef.current = exportList;
  }, [exportList]);

  useEffect(() => {
    userDataRef.current = userData
  }, [userData])

  useEffect(() => {
    if (userData?.credits !== undefined) {
      setCredits(userData.credits);
    }
  }, [userData]);

  useEffect(() => {
    if (engagedCreators && brandsList.length === 0) {
      paymentportalservice.FetchBrandsData()
        .then(raw => {
          const list = Array.isArray(raw) ? raw : (raw?.data || []);
          const normalized = list.map(b => ({
            _id: String(b._id || b.id || b.brandId || ''),
            name: b.name || b.brandName || b.title || '',
          })).filter(b => b._id && b.name);
          setBrandsList(normalized);
        })
        .catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engagedCreators, brandsList.length]);

  // Categories are a plain field on every influencer doc (unlike brands), so the
  // filter is always available — fetch the option list once on mount, no gating.
  useEffect(() => {
    filterServices.FetchCategories()
      .then(res => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setCategoriesList(list);
      })
      .catch(() => {});
  }, []);

  // State is also a plain field on every influencer doc — same fetch-once-on-mount
  // pattern as categories. The returned values are real, exact-cased distinct DB
  // values, so the Location filter can match them with an indexed equality query
  // instead of the previous broken/fuzzy regex.
  useEffect(() => {
    filterServices.FetchStates()
      .then(res => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setStatesList(list);
      })
      .catch(() => {});
  }, []);

  const handleContactRequestButton = useCallback(async (name) => {
    const Swal = await loadSwal();
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.REQUEST_CONTACT,
      action: ANALYTICS_ACTIONS.CREATOR_NAME,
      label: name,
    });

    const response = await pluginrequests.requestContactNumber({
      handle: `${name}` + ":",
    });

    if (response["success"]) {
      setUsername(prev => [...prev, name]);
      Swal.fire({
        position: "top-center",
        icon: "success",
        title: `${response["message"]}`,
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: response["message"],
      });
    }
  }, []);

  const handleContactButton = useCallback(async (influencerId, username, profile) => {
    const Swal = await loadSwal();
    const foundNumber = numbers.find((list) => list.username === username);
    // `numbers` comes from users/viewedInfluencers, which now returns `contactNumbers`
    // (array) instead of a scalar `.number` — helper handles both shapes.
    const foundNumberValue = helpers.getPrimaryContactNumber(foundNumber);
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.VIEW_CONTACT,
      action: ANALYTICS_ACTIONS.CREATOR_NAME,
      label: username,
    });

    if (foundNumberValue) {
      showContactModal(Swal, username, foundNumberValue, profile);
    } else {
      Swal.fire({
        title: "Are you sure?",
        text: `${username} 1 credit burn to view the number`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await pluginrequests.getContactNumber({
            uniqueId: influencerId,
            handle: username,
          });
          if (response["success"]) {
            setUpdateDashboardCredits(true);
            setCookie("logindata");
            setUpdateDashboardCredits(false);
            showContactModal(Swal, username, response.data.phone, profile);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response["message"],
            });
          }
        }
      });
    }
  }, [numbers, setCookie]);

  const handleEmailButton = useCallback(async (email, username) => {
    const Swal = await loadSwal();
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.VIEW_EMAIL,
      action: ANALYTICS_ACTIONS.CREATOR_NAME,
      label: username,
    });

    Swal.fire({
      title: "Are you sure?",
      text: `${username} 1 credit burn to view the email`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Done!",
          `1 credit burned for this username ${username}`,
          "success"
        );
        Swal.fire(email);
      }
    });
  }, []);

  const handlePageChange = useCallback((event, value) => {
    setPage(value);
    setCursor(nextCursorRef.current);
  }, []);

  const handleUserResponse = async () => {
    const result = await usersEndpoints.getUserDetails();
    setUserData(result);

    if (result?.credits !== undefined) {
      setCredits(result.credits);
    }

    if (result && result.user && result.user.email) {
      ReactGA.set({ user_email: result.user.fullName });
    }
  };
  const handleCheckboxClick = useCallback(async (event, value, id) => {

  const currentUserData = userDataRef.current;
  const userBalance = currentUserData?.credits ?? 0;
  const currentPlatform = filters?.platform || null;

  let foundNumber = numbers.find((list) => {
    if (currentPlatform === "Youtube") {
      return list.youtubeData?.channel_id === value;
    }
    return list.username === value;
  });
  // `numbers` comes from users/viewedInfluencers, which now returns `contactNumbers`
  // (array) instead of a scalar `.number` — helper handles both shapes.
  const foundNumberValue = helpers.getPrimaryContactNumber(foundNumber);

  const currentExportList = exportListRef.current;
  const isAlreadySelected = currentExportList.includes(value);

  if (event.target.checked && !isAlreadySelected) {

    if (selectedRowsRef.current === 100) {
      const Swal = (await loadSwal());
      Swal.fire({ icon: "error", title: "Oops...", text: "Your limit is 100" });
      return;
    }

    if (!foundNumberValue && selectedCheckboxRef.current >= userBalance) {
      const Swal = await loadSwal();
      Swal.fire({ icon: "error", title: "Oops...", text: "You don't have enough credits." });
      return;
    }

    if (!foundNumberValue) {
      setSelectCheckbox(prev => prev + 1);
    }
    setSelectedRows(prev => prev + 1);
    setExportList(prev => [...prev, value]);

  } else if (!event.target.checked && isAlreadySelected) {
    if (!foundNumberValue) {
      setSelectCheckbox(prev => prev - 1);
    }
    setSelectedRows(prev => prev - 1);
    setExportList(prev => prev.filter(item => item !== value));
  }

}, [filters?.platform, numbers]);

  const handleDeselectAll = useCallback(() => {
    setExportList([]);
    setSelectedRows(0);
    setSelectCheckbox(0);
  }, []);

  const handleOpenAddToPlan = useCallback(() => {
    setAddToPlanOpen(true);
  }, []);

  // exportList holds identifiers (username / youtubeData.channel_id), not the
  // Mongo _id an "add to plan" call needs — cross-reference against allCreators
  // (every row loaded so far) to get each selected creator's real RapidInfluencer
  // _id (plus a bit of display info for the drawer's avatar-stack preview) at
  // the moment the drawer opens.
  const addToPlanPlatform = { Youtube: 'youtube', Twitter: 'twitter', Linkedin: 'linkedin' }[filters?.platform] || 'instagram';
  const selectedCreatorsForPlan = useMemo(() => {
    if (!addToPlanOpen || exportList.length === 0) return [];
    const isYoutube = addToPlanPlatform === 'youtube';
    const selectedSet = new Set(exportList);
    const picked = [];
    for (const creator of allCreators) {
      const identifier = isYoutube ? creator.youtubeData?.channel_id : creator.username;
      if (identifier && selectedSet.has(identifier)) {
        const id = creator.id || creator._id;
        if (!id) continue;
        picked.push({
          id: String(id),
          username: creator.username || creator.youtubeData?.handle || '',
          name: creator.full_name || creator.youtubeData?.title || creator.name || creator.username || '',
          // youtubeData has no stored thumbnail/avatar field (confirmed against
          // real documents) — YouTube rows fall back to the initials avatar.
          avatar: creator.profile_pic_url_hd || creator.picture || creator.profile_pic_url || null,
        });
      }
    }
    return picked;
  }, [addToPlanOpen, exportList, allCreators, addToPlanPlatform]);

  // Always-fresh selection executor — stored in a ref so the auto-load
  // useEffect can call it without capturing stale closures.
  doSelectHundredRef.current = () => {
    const isYoutube = filters?.platform === 'Youtube';
    const current = exportListRef.current;
    const selectedIds = new Set(current);
    const numberById = new Map();
    for (const n of numbers) {
      const key = isYoutube ? n.youtubeData?.channel_id : n.username;
      if (key) numberById.set(key, n);
    }

    const newIds = [];
    let newCreditsNeeded = 0;
    for (const profile of allCreators) {
      if (newIds.length + current.length >= selectCount) break;
      const id = isYoutube ? profile.youtubeData?.channel_id : profile.username;
      if (!id || selectedIds.has(id)) continue;
      selectedIds.add(id);
      newIds.push(id);
      // numberById entries come from users/viewedInfluencers, which now returns
      // `contactNumbers` (array) instead of a scalar `.number` — helper handles both.
      const hasNumber = !!helpers.getPrimaryContactNumber(numberById.get(id));
      if (!hasNumber) newCreditsNeeded++;
    }
    if (newIds.length > 0) {
      setExportList(prev => [...prev, ...newIds]);
      setSelectedRows(prev => prev + newIds.length);
      setSelectCheckbox(prev => prev + newCreditsNeeded);
    }
  };

  const handleSelectHundred = useCallback(() => {
    if (allCreators.length === 0) return;
    if (allCreators.length >= selectCount || !hasMore) {
      doSelectHundredRef.current();
    } else {
      setSelectingHundred(true);
    }
  }, [allCreators, hasMore, selectCount]);

  const handleExportClick = useCallback(async () => {
    const Swal = await loadSwal();
    const response = await usersEndpoints.FetchExportCSVData({
      list: exportList,
      platform: filters.platform,
    });

    if (response["success"]) {
      setUpdateDashboardCredits(prev => !prev);
      if (response.balance !== undefined) {
        setCredits(response.balance);
      }
      // users/exportcsv now only returns the raw `categories`/`contactNumbers` arrays
      // (no more joined `categoryName` / scalar `number`) — the CSV headers below still
      // key off "categoryName"/"number", so derive those flat fields client-side.
      const rows = (response.data || []).map((row) => ({
        ...row,
        categoryName: helpers.getCategoryDisplay(row),
        number: helpers.getPrimaryContactNumber(row),
        profileUrl: row.username ? `https://www.instagram.com/${row.username}` : "",
      }));
      setExportData(rows);
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: response["message"],
      });
    }
  }, [exportList, filters.platform]);

  // Excel export is built server-side (ExcelJS) and archived to S3, unlike the
  // CSV path above which streams the JSON straight into react-csv — so this
  // gets back a signed download URL instead of rows, and triggers a plain
  // browser download rather than rendering a <CSVDownload>.
  const handleExportExcelClick = useCallback(async () => {
    const Swal = await loadSwal();
    setIsExportingExcel(true);
    try {
      const response = await usersEndpoints.FetchExportExcelData({
        list: exportList,
        platform: filters.platform,
      });

      if (response["success"]) {
        setUpdateDashboardCredits(prev => !prev);
        if (response.balance !== undefined) {
          setCredits(response.balance);
        }
        triggerBrowserDownload(response.downloadUrl);
        ReactGA.event({
          category: ANALYTICS_CATEGORIES.EXPORT,
          action: ANALYTICS_ACTIONS.REPORT_EXPORT,
          label: `${exportList.length} creators (excel)`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response["message"],
        });
      }
    } catch (error) {
      // Unlike /exportcsv (always 200, success flag in body), /exportexcel can
      // return a real error status (e.g. 503 when S3 archiving fails) — axios
      // rejects for those, so they land here rather than the success===false branch above.
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.message || "Failed to export to Excel. Please try again.",
      });
    } finally {
      setIsExportingExcel(false);
    }
  }, [exportList, filters.platform]);

  const handleFilters = useCallback((filterValue, filterType) => {
    let value = filterValue;

    if (filterType === "followers") {
      if (minRange || maxRange) {
        if (minRange && maxRange && Number(maxRange) <= Number(minRange)) {
          setFollowersRangeError("Max must be greater than min");
          return;
        }
        setFollowersRangeError("");
        value = {
          range: `${minRange}-${maxRange}`,
          isCustom: true,
        };

        ReactGA.event({
          category: ANALYTICS_CATEGORIES.FILTER,
          action: ANALYTICS_ACTIONS.FOLLOWERS,
          label: value.range,
          value: 2,
        });
      } else {
        value = followers;
      }
    }

    if (filterType === "age") {
      if (minAgeRange || maxAgeRange) {
        if (minAgeRange && maxAgeRange && Number(maxAgeRange) <= Number(minAgeRange)) {
          setAgeRangeError("Max must be greater than min");
          return;
        }
        setAgeRangeError("");
        value = {
          agerange: `${minAgeRange}-${maxAgeRange}`,
        };

        ReactGA.event({
          category: ANALYTICS_CATEGORIES.FILTER,
          action: ANALYTICS_ACTIONS.AGE,
          label: value.agerange,
          value: 2,
        });
      } else {
        value = age;
      }
    }

    if (filterType === "reelCost") {
      if (minReelCostRange || maxReelCostRange) {
        if (minReelCostRange && maxReelCostRange && Number(maxReelCostRange) <= Number(minReelCostRange)) {
          setReelCostRangeError("Max must be greater than min");
          return;
        }
        setReelCostRangeError("");
        value = {
          reelcostrange: `${minReelCostRange}-${maxReelCostRange}`,
        };

        ReactGA.event({
          category: ANALYTICS_CATEGORIES.FILTER,
          action: ANALYTICS_ACTIONS.REEL_COST,
          label: value.reelcostrange,
          value: 2,
        });
      } else {
        value = reelCost;
      }
    }

    if (filterType === "realCost") {
      if (minRealCostRange && maxRealCostRange && Number(maxRealCostRange) <= Number(minRealCostRange)) {
        setRealCostRangeError("Max must be greater than min");
        return;
      }
      setRealCostRangeError("");
      value = realCost;
    }

    if (filterType === "location") {
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.LOCATION,
        label: filterValue,
        value: 1,
      });
    }

    if (filterType === "gender") {
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.GENDER,
        label: filterValue,
        value: 1,
      });
    }

    if (filterType === "platform") {
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.PLATFORM,
        label: filterValue,
        value: 1,
      });
    }

    if (filterType === "topYoutubers") {
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.TOP_CREATORS_YT,
        label: filterValue,
        value: 1,
      });
    }

    if (filterType === "getNumbers" && !isContacts) {
      setContacts(true);
    }
    else if (filterType === "getNumbers" && isContacts) {
      setContacts(false);
    }

    // if (filterType === "engagedCreators") {
    //   setEngagedCreators(filterValue);
    //   if (!filterValue) setEngagedSort('followers');
    //   setCursor(null);
    //   setPage(1);
    //   return;
    // }
    if (filterType === "engagedCreators") {
      setEngagedCreators(filterValue);
      if (!filterValue) {
        setEngagedSort('followers');
        setFilters(prev => ({ ...prev, engagedCreators: null, realCost: null, brands: null, cpe: null, cpv: null }));
        setRealCost({ realcostrange: "" });
        setRealCostSliderValue([0, 1000000]);
        setMinRealCostRange("");
        setMaxRealCostRange("");
        setRealCostRangeError("");
        setSelectedBrands([]);
        setMinCPERange('');
        setMaxCPERange('');
        setCPERangeError('');
        setMinCPVRange('');
        setMaxCPVRange('');
        setCPVRangeError('');
      } else {
        setFilters((prev) => ({ ...prev, engagedCreators: filterValue }));
      }
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      return ;
    }

    if (filterType === "brands") {
      const brands = Array.isArray(filterValue) && filterValue.length ? filterValue : null;
      setFilters((prev) => ({ ...prev, brands }));
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      return;
    }

    if (filterType === "categories") {
      const categories = Array.isArray(filterValue) && filterValue.length ? filterValue : null;
      setFilters((prev) => ({ ...prev, categories }));
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.CATEGORY,
        label: categories ? categories.join(", ") : "",
        value: categories ? categories.length : 0,
      });
      return;
    }

    if (filterType === "languages") {
      const languages = Array.isArray(filterValue) && filterValue.length ? filterValue : null;
      setFilters((prev) => ({ ...prev, languages }));
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.LANGUAGE,
        label: languages ? languages.join(", ") : "",
        value: languages ? languages.length : 0,
      });
      return;
    }

    if (filterType === "flaggedCreators") {
      setFlaggedCreators(filterValue);
      if (!filterValue) {
        setSelectedStars([]);
        setFilters(prev => ({ ...prev, ratingFilters: null }));
      } else {
        setFilters(prev => ({ ...prev, ratingFilters: [] }));
      }
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      return;
    }

    if (filterType === "ratingFilters") {
      setSelectedStars(filterValue);
      setFilters(prev => ({ ...prev, ratingFilters: filterValue }));
      setAllCreators([]);
      setCursor(null);
      setPage(1);
      return;
    }

    setFilters((prev) => ({ ...prev, [filterType]: value }));

    setAllCreators([]);
    setCursor(null);
    setPage(1);
  }, [minRange, maxRange, followers, minAgeRange, maxAgeRange, age, minReelCostRange, maxReelCostRange, reelCost, realCost, minRealCostRange, maxRealCostRange, isContacts]);

  const handleBrandsChange = useCallback((newSelection) => {
    setSelectedBrands(newSelection);
  }, []);

  const handleCategoriesChange = useCallback((newSelection) => {
    setSelectedCategories(newSelection);
  }, []);

  const handleLanguagesChange = useCallback((newSelection) => {
    setSelectedLanguages(newSelection);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [min, max] = value.split('-').map(Number);
    const clampedMax = Math.min(max, 100000000);
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.FILTER,
      action: ANALYTICS_ACTIONS.FOLLOWERS,
      label: value,
      value: 1,
    });
    setFollowersRangeError('');
    setFollowers((prev) => ({ ...prev, [name]: value }));
    setFollowersSliderValue([min, clampedMax]);
    setMinRange(String(min));
    setMaxRange(String(clampedMax));
  };

  const handleAgeRangeChange = (e) => {
    const { name, value } = e.target;
    const [min, max] = value.split('-').map(Number);
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.FILTER,
      action: ANALYTICS_ACTIONS.AGE,
      label: value,
      value: 1,
    });
    setAgeRangeError('');
    setAge((prev) => ({ ...prev, [name]: value }));
    setAgeSliderValue([min, max]);
    setMinAgeRange(String(min));
    setMaxAgeRange(String(max));
  };

  const handleReelCostRangeChange = (e) => {
    const { name, value } = e.target;
    const [min, max] = value.split('-').map(Number);
    ReactGA.event({
      category: ANALYTICS_CATEGORIES.FILTER,
      action: ANALYTICS_ACTIONS.REEL_COST,
      label: value,
      value: 1,
    });
    setReelCostRangeError('');
    setReelCost((prev) => ({ ...prev, [name]: value }));
    setReelCostSliderValue([min, max]);
    setMinReelCostRange(String(min));
    setMaxReelCostRange(String(max));
  };

  const handleFollowersChange = (e) => {
    const { name, value } = e.target;
    setFollowersRangeError('');
    setFollowers({ range: '', isCustom: false });
    if (name === 'minrange') {
      setMinRange(value);
      const num = Number(value) || 0;
      setFollowersSliderValue([Math.min(Math.max(num, 0), 100000000), followersSliderValue[1]]);
    } else {
      setMaxRange(value);
      const num = Number(value) || 0;
      setFollowersSliderValue([followersSliderValue[0], Math.min(Math.max(num, 0), 100000000)]);
    }
  };

  const handleAgeChange = (e) => {
    const { name, value } = e.target;
    setAgeRangeError('');
    setAge({ agerange: '' });
    if (name === 'minAgeRange') {
      setMinAgeRange(value);
      const num = Number(value) || 18;
      setAgeSliderValue([Math.min(Math.max(num, 18), 65), ageSliderValue[1]]);
    } else {
      setMaxAgeRange(value);
      const num = Number(value) || 65;
      setAgeSliderValue([ageSliderValue[0], Math.min(Math.max(num, 18), 65)]);
    }
  };

  const handleReelCostChange = (e) => {
    const { name, value } = e.target;
    setReelCostRangeError('');
    setReelCost({ reelcostrange: '' });
    if (name === 'minReelCostRange') {
      setMinReelCostRange(value);
      const num = Number(value) || 0;
      setReelCostSliderValue([Math.min(Math.max(num, 0), 1000000), reelCostSliderValue[1]]);
    } else {
      setMaxReelCostRange(value);
      const num = Number(value) || 0;
      setReelCostSliderValue([reelCostSliderValue[0], Math.min(Math.max(num, 0), 1000000)]);
    }
  };

  const handleFollowersSliderChange = useCallback((_, [min, max]) => {
    setFollowersRangeError('');
    setFollowers({ range: `${min}-${max}`, isCustom: true });
    setMinRange(String(min));
    setMaxRange(String(max));
    setFollowersSliderValue([min, max]);
  }, []);

  const handleAgeSliderChange = useCallback((_, [min, max]) => {
    setAgeRangeError('');
    setAge({ agerange: `${min}-${max}` });
    setMinAgeRange(String(min));
    setMaxAgeRange(String(max));
    setAgeSliderValue([min, max]);
  }, []);

  const handleReelCostSliderChange = useCallback((_, [min, max]) => {
    setReelCostRangeError('');
    setReelCost({ reelcostrange: `${min}-${max}` });
    setMinReelCostRange(String(min));
    setMaxReelCostRange(String(max));
    setReelCostSliderValue([min, max]);
  }, []);

  const handleRealCostSliderChange = (event, newValue) => {
    setRealCostSliderValue(newValue);
    setRealCost({ realcostrange: `${newValue[0]}-${newValue[1]}` });
    setMinRealCostRange(String(newValue[0]));
    setMaxRealCostRange(String(newValue[1]));
    setRealCostRangeError("");
  };

  const handleRealCostRangeChange = (e) => {
    const { value } = e.target;
    const [min, max] = value.split('-').map(Number);
    setRealCost({ realcostrange: value });
    setRealCostSliderValue([min, max]);
    setMinRealCostRange(String(min));
    setMaxRealCostRange(String(max));
    setRealCostRangeError("");
  };

  const handleRealCostInputChange = (e) => {
    const { name, value } = e.target;
    setRealCostRangeError("");
    if (name === "minRealCostRange") {
      setMinRealCostRange(value);
      const numVal = Number(value) || 0;
      setRealCostSliderValue([Math.min(Math.max(numVal, 0), 1000000), realCostSliderValue[1]]);
      setRealCost({ realcostrange: `${numVal}-${realCostSliderValue[1]}` });
    } else {
      setMaxRealCostRange(value);
      const numVal = Number(value) || 0;
      setRealCostSliderValue([realCostSliderValue[0], Math.min(Math.max(numVal, 0), 1000000)]);
      setRealCost({ realcostrange: `${realCostSliderValue[0]}-${numVal}` });
    }
  };

  const handleCPEInputChange = (e) => {
    const { name, value } = e.target;
    setCPERangeError('');
    if (name === 'minCPERange') setMinCPERange(value);
    else setMaxCPERange(value);
  };

  const handleApplyCPE = () => {
    const min = minCPERange !== '' ? Number(minCPERange) : null;
    const max = maxCPERange !== '' ? Number(maxCPERange) : null;
    if (min === null && max === null) {
      setFilters(prev => ({ ...prev, cpe: null }));
      return;
    }
    if (min != null && max != null && max <= min) {
      setCPERangeError('Max must be greater than min');
      return;
    }
    setCPERangeError('');
    const range = [min != null ? min : '', max != null ? max : ''].join('-');
    setFilters(prev => ({ ...prev, cpe: { cperange: range } }));
    setAllCreators([]);
    setCursor(null);
    setPage(1);
  };

  const handleCPVInputChange = (e) => {
    const { name, value } = e.target;
    setCPVRangeError('');
    if (name === 'minCPVRange') setMinCPVRange(value);
    else setMaxCPVRange(value);
  };

  const handleApplyCPV = () => {
    const min = minCPVRange !== '' ? Number(minCPVRange) : null;
    const max = maxCPVRange !== '' ? Number(maxCPVRange) : null;
    if (min === null && max === null) {
      setFilters(prev => ({ ...prev, cpv: null }));
      return;
    }
    if (min != null && max != null && max <= min) {
      setCPVRangeError('Max must be greater than min');
      return;
    }
    setCPVRangeError('');
    const range = [min != null ? min : '', max != null ? max : ''].join('-');
    setFilters(prev => ({ ...prev, cpv: { cpvrange: range } }));
    setAllCreators([]);
    setCursor(null);
    setPage(1);
  };

  const handleEnterKeyPress = useCallback((event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const term = event.target.value.trim().replace(/^@/, "");
      if (!term) return;

      ReactGA.event({
        category: ANALYTICS_CATEGORIES.FILTER,
        action: ANALYTICS_ACTIONS.SEARCH_TERM,
        label: term,
        value: 2,
      });

      setFilters((prevState) => {
        const existing = prevState.search || [];
        if (existing.some((t) => t.toLowerCase() === term.toLowerCase()))
          return prevState;
        return { ...prevState, search: [...existing, term] };
      });

      setCursor(null);
      setPage(1);
      if (inputRef.current) inputRef.current.value = "";
    }
  }, []);

  const handleDelete = useCallback((filter, index) => {
    if (filter === "gender") setGender("");
    if (filter === "platform") setPlatform("");
    if (filter === "age") {
      setAge({ agerange: "" });
      setMinAgeRange("");
      setMaxAgeRange("");
    }
    if (filter === "followers") {
      setFollowers({ range: "", isCustom: false });
      setMinRange("");
      setMaxRange("");
    }
    if (filter === "reelCost") {
      setReelCost({ reelcostrange: "" });
      setMinReelCostRange("");
      setMaxReelCostRange("");
    }
    if (filter === 'location') {
      setLocation("");
    }
    if (filter === "engagedCreators") {
      setEngagedCreators(false);
      setEngagedSort('followers');
    }
    if (filter === "realCost") {
      setRealCost({ realcostrange: "" });
      setRealCostSliderValue([0, 1000000]);
      setMinRealCostRange("");
      setMaxRealCostRange("");
      setRealCostRangeError("");
    }
    if (filter === "brands") {
      setSelectedBrands([]);
    }
    if (filter === "categories") {
      setSelectedCategories([]);
    }
    if (filter === "languages") {
      setSelectedLanguages([]);
    }
    if (filter === "cpe") {
      setMinCPERange('');
      setMaxCPERange('');
      setCPERangeError('');
    }
    if (filter === "cpv") {
      setMinCPVRange('');
      setMaxCPVRange('');
      setCPVRangeError('');
    }

    if (inputRef.current) inputRef.current.value = "";

    setFilters((prev) => {
      if (filter === "search" && Array.isArray(prev[filter])) {
        const updated = [...prev[filter]];
        updated.splice(index, 1);
        return { ...prev, [filter]: updated.length === 0 ? "" : updated };
      }
      if (filter === "cpe" || filter === "cpv") {
        return { ...prev, [filter]: null };
      }
      return { ...prev, [filter]: "" };
    });

    setCursor(null);
    if (filter === "getNumbers") setContacts(false);
  }, []);

  const handleClearFilters = useCallback(() => {
    setFilters(initialFilter);
    setContacts(false);
    setCursor(null);
    setAllCreators([]);
    setPage(1);
    setGender("");
    setPlatform("");
    setLocation("");
    setMinRange("");
    setMaxRange("");
    setMinAgeRange("");
    setMaxAgeRange("");
    setMinReelCostRange("");
    setMaxReelCostRange("");
    setFollowers({ range: "", isCustom: false })
    setAge({ agerange: "" });
    setReelCost({ reelcostrange: "" });
    setRealCost({ realcostrange: "" });
    setRealCostSliderValue([0, 1000000]);
    setMinRealCostRange("");
    setMaxRealCostRange("");
    setRealCostRangeError("");
    setSelectedBrands([]);
    setSelectedCategories([]);
    setSelectedLanguages([]);
    setFlaggedCreators(false);
    setSelectedStars([]);
    setMinCPERange('');
    setMaxCPERange('');
    setCPERangeError('');
    setMinCPVRange('');
    setMaxCPVRange('');
    setCPVRangeError('');

    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setTableSort({ age: null, followers: null, gender: null });
    setSelectedRows(0);
    setSelectCheckbox(0);
    setExportList([]);
    setFollowersRangeError("");
    setAgeRangeError("");
    setReelCostRangeError("");
    setEngagedCreators(false);
  }, []);

  const ageFormatter = useCallback((value) => {
    if (!value) return "—";
    const ageYear = Number(value.split("-")[0]);
    const currentYear = new Date().getFullYear();
    const bornAge = currentYear - ageYear;
    return bornAge >= 15 && bornAge <= 80 ? bornAge : "—";
  }, []);

  const categoryFormatter = useCallback((value) => {
    if (!value?.length) return "";
    const chips = value
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean)
      .map((c, i) => (
        <Chip
          key={i}
          label={c}
          size="small"
          sx={{
            m: 0.25,
            fontFamily: 'Quicksand',
            fontWeight: 700,
            fontSize: '0.68rem',
            bgcolor: 'rgba(255,82,0,0.08)',
            color: '#CC4200',
            border: '1px solid rgba(255,82,0,0.2)',
            height: 22,
          }}
        />
      ));
    return <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>{chips}</Box>;
  }, []);

  const contactFormatter = useCallback((id, isNumber, name, profile) => {
    const foundRequest =
      requestNumbers?.influencer_handle?.find(
        (list) => list.split(":")[0] === name
      );

    return (
      <>
        {isNumber && !numbers.find((list) => list.username === name) ? (
          <Button
            variant="outlined"
            size="small"
            sx={buttonCss}
            onClick={() => handleContactButton(id, name, profile)}
          >
            Show Details <Lock sx={{ fontSize: "10px" }} />
          </Button>
        ) : (!isNumber && foundRequest) ||
          username.find((list) => list === name) ? (
          <Button variant="contained" size="small" sx={buttonCss} disabled>
            Requested
          </Button>
        ) : !isNumber && !foundRequest ? (
          <Button
            size="small"
            sx={buttonCss}
            onClick={() => handleContactRequestButton(name)}
          >
            Request Contact
          </Button>
        ) : (
          <Button
            variant="contained"
            size="small"
            sx={buttonCss}
            onClick={() => handleContactButton(id, name, profile)}
          >
            Show Details
          </Button>
        )}
      </>
    );
  }, [requestNumbers, numbers, username, handleContactButton, handleContactRequestButton]);

  const handleCreatorDelete = useCallback(async (id) => {
    const response = await influencerservice.removeCreator(id);
    if (!response?.success) return;
    setAllCreators((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const Init = useCallback(async () => {
    const responseNumbers = await usersEndpoints.viewedInfluencersList();
    const requestResponse = await pluginrequests.viewRequestedInfluencersNumbers();
    setNumbers(responseNumbers["data"]);
    setRequestNumbers(requestResponse["data"]);
  }, []);

  const handleSort = useCallback((path) => {
    setTableSort((prev) => ({
      ...prev,
      [path]: prev[path] === "asc" ? "desc" : "asc",
    }));
  }, []);

  useEffect(() => {
    handleUserResponse().catch(console.error);
  }, []);

  useEffect(() => {
    if (exportData.length) {
      setInitiateDownload(true);
      ReactGA.event({
        category: ANALYTICS_CATEGORIES.EXPORT,
        action: ANALYTICS_ACTIONS.REPORT_EXPORT,
        label: `${exportData.length} creators`,
      });
    }
  }, [exportData]);

  useEffect(() => {
    if (initiateDownload) setInitiateDownload(false);
  }, [initiateDownload]);

  useEffect(() => {
    Init().catch(console.error);
  }, []);

  useEffect(() => {
    if (!isContacts) {
      setFilters((prev) => ({ ...prev, getNumbers: null }));
    }
    setCursor(null);
  }, [isContacts]);

  const {
    data: profiles,
    isLoading: profilesLoading,
    isFetching,
    isError: profilesError,
  } = useFilteredInfluencers(filters, tableSort, page, isContacts, cursor, engagedCreators, engagedSort);

  const handleEngagedSort = (val) => {
    if (!val) return;
    setEngagedSort(val);
    setCursor(null);
    setPage(1);
    setAllCreators([]);
  };

  const {
    data: count,
    isLoading: countLoading,
  } = useFetchInfluencersCount(filters, isContacts, engagedCreators);

  useEffect(() => {
    // Guard: don't reset cursor/hasMore while a fetch is in flight (data would be stale/undefined)
    if (!profiles?.data) return;
    const nextCursor = profiles.data.cursor;
    nextCursorRef.current = nextCursor || null;
    setHasMore(!!nextCursor);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profiles?.data?.cursor]);

  useEffect(() => {
    if (!profiles?.data?.influencers) { return; }

    setAllCreators(prev => {
      if (page === 1) {
        return profiles.data.influencers;
      }

      const ids = new Set(prev.map(creator => creator._id));
      const newItems = profiles.data.influencers.filter(x => !ids.has(x._id));
      return [...prev, ...newItems];
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profiles]);

  // Auto-load pages until selectCount creators are available, then select them.
  // Wait for isFetching to clear before acting — prevents triggering on stale
  // hasMore/cursor values that exist mid-flight between page increments.
  useEffect(() => {
    if (!selectingHundred || isFetching) return;
    if (allCreators.length >= selectCount || !nextCursorRef.current) {
      doSelectHundredRef.current();
      setSelectingHundred(false);
    } else {
      setPage(prev => prev + 1);
      setCursor(nextCursorRef.current);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCreators, selectingHundred, selectCount, isFetching]);

  return (
    <>
      <DashboardHeaderSection
        inputRef={inputRef}
        isSearchOpen={false}
        updateCredits={updateDashboardCredits}
        handleEnterKeyPress={handleEnterKeyPress}
        isYoutube={filters.platform === "Youtube"}
      />
      <FilterSliderBar
        isMobileFilter={isMobileFilter}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        handleClearFilters={handleClearFilters}
        filters={filters}
        handleDelete={handleDelete}
        gender={gender}
        setGender={setGender}
        handleFilters={handleFilters}
        location={location}
        setLocation={setLocation}
        statesList={statesList}
        minRange={minRange}
        maxRange={maxRange}
        handleFollowersChange={handleFollowersChange}
        followers={followers}
        handleChange={handleChange}
        minAgeRange={minAgeRange}
        maxAgeRange={maxAgeRange}
        handleAgeChange={handleAgeChange}
        age={age}
        handleAgeRangeChange={handleAgeRangeChange}
        minReelCostRange={minReelCostRange}
        maxReelCostRange={maxReelCostRange}
        handleReelCostChange={handleReelCostChange}
        reelCost={reelCost}
        handleReelCostRangeChange={handleReelCostRangeChange}
        followersRangeError={followersRangeError}
        ageRangeError={ageRangeError}
        reelCostRangeError={reelCostRangeError}
        platform={platform}
        setPlatform={setPlatform}
        realCost={realCost}
        realCostSliderValue={realCostSliderValue}
        handleRealCostSliderChange={handleRealCostSliderChange}
        handleRealCostRangeChange={handleRealCostRangeChange}
        minRealCostRange={minRealCostRange}
        maxRealCostRange={maxRealCostRange}
        handleRealCostInputChange={handleRealCostInputChange}
        realCostRangeError={realCostRangeError}
        brandsList={brandsList}
        selectedBrands={selectedBrands}
        handleBrandsChange={handleBrandsChange}
        categoriesList={categoriesList}
        selectedCategories={selectedCategories}
        handleCategoriesChange={handleCategoriesChange}
        languagesList={languagesList}
        selectedLanguages={selectedLanguages}
        handleLanguagesChange={handleLanguagesChange}
        count={count}
        countLoading={countLoading}
        isContacts={isContacts}
        engagedCreators={engagedCreators}
        engagedSort={engagedSort}
        handleEngagedSort={handleEngagedSort}
        flaggedCreators={flaggedCreators}
        selectedStars={selectedStars}
        minCPERange={minCPERange}
        maxCPERange={maxCPERange}
        cpeRangeError={cpeRangeError}
        handleCPEInputChange={handleCPEInputChange}
        minCPVRange={minCPVRange}
        maxCPVRange={maxCPVRange}
        cpvRangeError={cpvRangeError}
        handleCPVInputChange={handleCPVInputChange}
        handleApplyCPE={handleApplyCPE}
        handleApplyCPV={handleApplyCPV}
        handleFiltersToolbar={handleFilters}
        exportList={exportList}
        handleExportClick={handleExportClick}
        handleExportExcelClick={handleExportExcelClick}
        isExportingExcel={isExportingExcel}
        initiateDownload={initiateDownload}
        exportData={exportData}
        profilesLoading={profilesLoading}
        isFetching={isFetching}
        profilesError={profilesError}
        profiles={profiles}
        allCreators={allCreators}
        credits={credits}
        numbers={numbers}
        ageFormatter={ageFormatter}
        contactFormatter={contactFormatter}
        categoryFormatter={categoryFormatter}
        handleEmailButton={handleEmailButton}
        handleCheckboxClick={handleCheckboxClick}
        handleContactRequestButton={handleContactRequestButton}
        handleSort={handleSort}
        tableSort={tableSort}
        cookies={cookies}
        handleCreatorDelete={handleCreatorDelete}
        handlePageChange={handlePageChange}
        page={page}
        cursor={cursor}
        onDeselectAll={handleDeselectAll}
        onOpenAddToPlan={handleOpenAddToPlan}
        onSelectHundred={handleSelectHundred}
        hasMore={hasMore}
        isSelectingHundred={selectingHundred}
        selectCount={selectCount}
        onSelectCountChange={setSelectCount}
        followersSliderValue={followersSliderValue}
        handleFollowersSliderChange={handleFollowersSliderChange}
        ageSliderValue={ageSliderValue}
        handleAgeSliderChange={handleAgeSliderChange}
        reelCostSliderValue={reelCostSliderValue}
        handleReelCostSliderChange={handleReelCostSliderChange}
      />
      <AddToPlanDrawer
        open={addToPlanOpen}
        onClose={() => setAddToPlanOpen(false)}
        selectedCreators={selectedCreatorsForPlan}
        platform={addToPlanPlatform}
        onDone={() => {
          handleDeselectAll();
          setAddToPlanOpen(false);
        }}
      />
    </>
  );
};

export default InfluencerFilters;